
// ============================================
// STATIC CATEGORIES — fallback dacă userul nu a configurat nimic
// ============================================
window.AH_STATIC_CATS = [
  {
    "handle": "toate-produsele",
    "label": "Toate produsele",
    "emoji": "🛒",
    "url": "/collections/toate-produsele",
    "subs": []
  },
  {
    "handle": "vita-1",
    "label": "Carne de vită",
    "emoji": "🥩",
    "url": "/collections/vita-1",
    "subs": []
  },
  {
    "handle": "oaie",
    "label": "Carne de oaie",
    "emoji": "🐑",
    "url": "/collections/oaie",
    "subs": []
  },
  {
    "handle": "carne-de-pui",
    "label": "Carne de pui",
    "emoji": "🐔",
    "url": "/collections/carne-de-pui",
    "subs": []
  },
  {
    "handle": "preparate-din-cane",
    "label": "Preparate din carne",
    "emoji": "🍖",
    "url": "/collections/preparate-din-cane",
    "subs": []
  },
  {
    "handle": "lactate",
    "label": "Lactate",
    "emoji": "🥛",
    "url": "/collections/lactate",
    "subs": []
  },
  {
    "handle": "alimente-congelate",
    "label": "Alimente congelate",
    "emoji": "❄️",
    "url": "/collections/alimente-congelate",
    "subs": []
  },
  {
    "handle": "nuci-si-curmale",
    "label": "Nuci și curmale",
    "emoji": "🌰",
    "url": "/collections/nuci-si-curmale",
    "subs": []
  },
  {
    "handle": "camara",
    "label": "Cămară",
    "emoji": "🫙",
    "url": "/collections/camara",
    "subs": []
  },
  {
    "handle": "ceai-cafea",
    "label": "Ceai și cafea",
    "emoji": "☕",
    "url": "/collections/ceai-cafea",
    "subs": []
  },
  {
    "handle": "conserve",
    "label": "Conserve",
    "emoji": "🥫",
    "url": "/collections/conserve",
    "subs": []
  },
  {
    "handle": "cereale-și-leguminoase",
    "label": "Cereale și leguminoase",
    "emoji": "🌾",
    "url": "/collections/cereale-și-leguminoase",
    "subs": []
  },
  {
    "handle": "uleiuri-și-sosuri",
    "label": "Uleiuri și sosuri",
    "emoji": "🫒",
    "url": "/collections/uleiuri-și-sosuri",
    "subs": []
  },
  {
    "handle": "dulciuri",
    "label": "Dulciuri",
    "emoji": "🍬",
    "url": "/collections/dulciuri",
    "subs": []
  },
  {
    "handle": "mancaruri-gata-1",
    "label": "Mâncăruri gata",
    "emoji": "🍽️",
    "url": "/collections/mancaruri-gata-1",
    "subs": []
  },
  {
    "handle": "condimente",
    "label": "Condimente",
    "emoji": "🌶️",
    "url": "/collections/condimente",
    "subs": []
  },
  {
    "handle": "panificație",
    "label": "Panificație",
    "emoji": "🍞",
    "url": "/collections/panificație",
    "subs": []
  },
  {
    "handle": "bauturi",
    "label": "Băuturi",
    "emoji": "🧃",
    "url": "/collections/bauturi",
    "subs": []
  }
];

/* Macelaria Anas Shopify Theme - Main JavaScript */
'use strict';

// Folosim lista verificată de colecții reale din magazin.
window.AH_NAV_CATS = window.AH_STATIC_CATS || [];

// ============================================
// CART STATE
// ============================================
const AnasCart = {
  items: [],

  /*
   * Quantity updates are optimistic and serialized.
   * Rapid taps update the visible quantity immediately, then send only the
   * latest requested quantity after a short debounce. This avoids concurrent
   * /cart/change.js requests racing and replacing newer quantities with stale data.
   */
  _loadSequence: 0,
  _quantityTimers: Object.create(null),
  _pendingQuantities: Object.create(null),
  _quantityRequestInFlight: null,
  _quantitySyncDelay: 130,
  _summaryFrame: null,

  getCount() {
    return this.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  },

  getTotal() {
    return this.items.reduce((sum, item) => sum + (Number(item.price || 0) * Number(item.quantity || 0)), 0);
  },

  addItem(product) {
    var self = this;
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: product.id, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Nu s-a putut adăuga produsul în coș.');
        return response.json();
      })
      .then(function () {
        return self.loadFromShopify();
      })
      .catch(function (error) {
        console.error('Cart add error:', error);
        return null;
      });
  },

  removeItem(id) {
    return this.updateQuantity(id, 0);
  },

  /* Use a delta rather than a hard-coded quantity in the rendered button.
     This lets rapid clicks build on the latest optimistic quantity without
     having to replace the whole drawer DOM after every click. */
  changeQuantityBy(id, delta) {
    const key = String(id);
    const item = this.items.find(function (cartItem) {
      return String(cartItem.id) === key;
    });
    if (!item) return;
    this.updateQuantity(key, Number(item.quantity || 0) + Number(delta || 0));
  },

  updateQuantity(id, qty) {
    const key = String(id);
    const item = this.items.find(function (cartItem) {
      return String(cartItem.id) === key;
    });
    if (!item) return;

    const nextQuantity = Math.max(0, Math.floor(Number(qty) || 0));

    /* Invalidate any /cart.js fetch that started before this user action. */
    this._loadSequence += 1;

    if (nextQuantity === 0) {
      this.items = this.items.filter(function (cartItem) {
        return String(cartItem.id) !== key;
      });
    } else {
      item.quantity = nextQuantity;
    }

    this._pendingQuantities[key] = nextQuantity;

    if (this._quantityTimers[key]) {
      window.clearTimeout(this._quantityTimers[key]);
    }
    this._quantityTimers[key] = window.setTimeout(() => {
      delete this._quantityTimers[key];
      this._flushQuantityChange(key);
    }, this._quantitySyncDelay);

    /* Fast local update: do not redraw every product card on every tap. */
    this._updateQuantityUI(key, nextQuantity);
  },

  _updateQuantityUI(id, quantity) {
    const key = String(id);

    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      const count = this.getCount();
      element.textContent = count;
      element.style.display = count > 0 ? 'flex' : 'none';
    });

    /* Removing the last unit changes the list structure; use the normal
       renderer in that case. For quantity changes above zero, update only
       the number and subtotal, preserving the drawer DOM and scroll position. */
    if (quantity <= 0) {
      this.updateUI();
      this._queueMinimumOrderUpdate();
      return;
    }

    const itemsEl = document.getElementById('cart-items');
    let row = null;
    if (itemsEl) {
      const rows = itemsEl.querySelectorAll('.cart-item[data-item-id]');
      for (let index = 0; index < rows.length; index += 1) {
        if (String(rows[index].getAttribute('data-item-id')) === key) {
          row = rows[index];
          break;
        }
      }
    }

    if (!row) {
      this.updateUI();
    } else {
      const number = row.querySelector('.qty-num');
      if (number) number.textContent = String(quantity);
    }

    const subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = this.getTotal().toFixed(0) + ' RON';

    this._queueMinimumOrderUpdate();
  },

  _queueMinimumOrderUpdate() {
    if (this._summaryFrame !== null) return;

    const run = () => {
      this._summaryFrame = null;
      if (typeof updateMinimumOrderCheck === 'function') {
        updateMinimumOrderCheck();
      }
    };

    if (typeof window.requestAnimationFrame === 'function') {
      this._summaryFrame = window.requestAnimationFrame(run);
    } else {
      this._summaryFrame = window.setTimeout(run, 16);
    }
  },

  _flushQuantityChange(id) {
    const key = String(id);

    if (this._quantityTimers[key]) {
      window.clearTimeout(this._quantityTimers[key]);
      delete this._quantityTimers[key];
    }

    /* One cart mutation at a time, across all lines, prevents stale cart
       snapshots from different requests from overwriting each other. */
    if (this._quantityRequestInFlight) return;
    if (!Object.prototype.hasOwnProperty.call(this._pendingQuantities, key)) return;

    const targetQuantity = Number(this._pendingQuantities[key]);
    this._quantityRequestInFlight = { id: key, quantity: targetQuantity };
    this._loadSequence += 1;

    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: targetQuantity })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            throw new Error(data.description || data.message || 'Shopify nu a putut actualiza cantitatea.');
          });
        }
        return response.json();
      })
      .then((cart) => {
        const activeRequest = this._quantityRequestInFlight;
        if (!activeRequest || activeRequest.id !== key || activeRequest.quantity !== targetQuantity) return;

        this._quantityRequestInFlight = null;

        if (this._quantityTimers[key]) {
          window.clearTimeout(this._quantityTimers[key]);
          delete this._quantityTimers[key];
        }

        const hasLatestTarget = Object.prototype.hasOwnProperty.call(this._pendingQuantities, key);
        const latestQuantity = this._pendingQuantities[key];

        /* If the user clicked again during the request, immediately send the
           newest target instead of applying the stale response. */
        if (hasLatestTarget && latestQuantity !== targetQuantity) {
          this._flushQuantityChange(key);
          return;
        }

        delete this._pendingQuantities[key];
        const pendingKeys = Object.keys(this._pendingQuantities);
        if (pendingKeys.length) {
          this._flushQuantityChange(pendingKeys[0]);
          return;
        }

        if (!cart || !Array.isArray(cart.items)) {
          this.loadFromShopify();
          return;
        }

        /* Invalidate any older cart fetch started while a quantity was pending. */
        this._loadSequence += 1;
        this._applyCartSnapshot(cart);
        this.updateUI();
        window.dispatchEvent(new CustomEvent('anas:drawer-cart-updated', {
          detail: { cart: cart }
        }));
      })
      .catch((error) => {
        const activeRequest = this._quantityRequestInFlight;
        if (activeRequest && activeRequest.id === key && activeRequest.quantity === targetQuantity) {
          this._quantityRequestInFlight = null;
        }

        const hasLatestTarget = Object.prototype.hasOwnProperty.call(this._pendingQuantities, key);
        const latestQuantity = this._pendingQuantities[key];
        if (hasLatestTarget && latestQuantity !== targetQuantity) {
          this._flushQuantityChange(key);
          return;
        }

        delete this._pendingQuantities[key];
        const pendingKeys = Object.keys(this._pendingQuantities);
        console.error('Cart quantity update error:', error);

        if (pendingKeys.length) {
          this._flushQuantityChange(pendingKeys[0]);
          return;
        }

        /* Recover the actual Shopify quantity after a failed mutation. */
        this._loadSequence += 1;
        this.loadFromShopify();
        if (typeof showToast === 'function') {
          showToast('Cantitatea nu a putut fi actualizată. Încearcă din nou.', 'error');
        }
      });
  },

  _applyCartSnapshot(cart) {
    this.items = cart.items.map((item) => ({
      id: String(item.variant_id || item.id),
      title: item.title,
      price: Number(item.final_price != null ? item.final_price : item.price || 0) / 100,
      originalPrice: Number(item.original_price || item.final_price || item.price || 0) / 100,
      isOnSale: false, // SALE is confirmed from the live variant compare_at_price below.
      quantity: Number(item.quantity || 0),
      image: item.image || '',
      vendor: item.vendor || '',
      properties: item.properties || {},
      isPerishable: String((item.properties || {})._perisabil || '').toLowerCase() === 'true',
      url: item.url || '',
      variantId: String(item.variant_id || item.id),
      compareAtPrice: Number(item.compare_at_price || 0),
      _comparePriceChecked: false
    }));
  },

  save() {
    // Shopify rămâne sursa de adevăr pentru coș.
  },

  load() {
    // Păstrat pentru compatibilitate cu restul temei.
  },

  loadFromShopify() {
    const requestSequence = ++this._loadSequence;

    /* Prevent Safari/mobile browsers from reusing a stale cart snapshot after /cart/add.js. */
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/') + 'cart.js?_anas_cart_refresh=' + Date.now(), {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Nu s-a putut sincroniza coșul Shopify.');
        return response.json();
      })
      .then((cart) => {
        /* Ignore stale GETs and don't replace optimistic quantities while a
           debounced or in-flight mutation is waiting to reach Shopify. */
        if (requestSequence !== this._loadSequence) return cart;
        if (this._quantityRequestInFlight || Object.keys(this._pendingQuantities).length) return cart;

        this._applyCartSnapshot(cart);
        this.updateUI();
        return cart;
      })
      .catch(function (error) {
        console.error('Cart sync error:', error);
        return null;
      });
  },

  updateUI() {
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      const count = this.getCount();
      element.textContent = count;
      element.style.display = count > 0 ? 'flex' : 'none';
    });
    this.renderDrawer();
  },

  refreshSaleStatuses() {
    // Invalidate cached product JSON and force each cart line to read the current compare-at price.
    window.AnasComparePriceCache = Object.create(null);
    this.items.forEach((item) => {
      item._comparePriceChecked = false;
      item._comparePriceCheckedAt = 0;
    });
    this.renderDrawer();
  },

  renderDrawer() {
    const itemsEl = document.getElementById('cart-items');
    const emptyEl = document.getElementById('cart-empty');
    const footerEl = document.getElementById('cart-footer');
    const subtotalEl = document.getElementById('cart-subtotal');

    if (!itemsEl) return;

    if (this.items.length === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'flex';
      if (footerEl) footerEl.style.display = 'none';
      if (subtotalEl) subtotalEl.textContent = '0 RON';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';

    // Confirm SALE from the live Shopify variant data, not cart discounts.
    // Cached product JSON has a short lifetime; opening the drawer forces a fresh check.
    const saleCheckNow = Date.now();
    this.items.forEach((item) => {
      if (!item.url) return;
      if (item._comparePriceChecked && item._comparePriceCheckedAt && saleCheckNow - item._comparePriceCheckedAt < 15000) return;

      item._comparePriceChecked = true;
      item._comparePriceCheckedAt = saleCheckNow;
      item._comparePriceRequestToken = Number(item._comparePriceRequestToken || 0) + 1;
      const requestToken = item._comparePriceRequestToken;

      const handleMatch = String(item.url).match(/\/products\/([^/?#]+)/);
      if (!handleMatch) {
        item._comparePriceChecked = false;
        return;
      }

      // Shopify may return a percent-encoded handle in cart.js; decode it once before building the product JSON URL.
      let decodedHandle = handleMatch[1];
      try {
        decodedHandle = decodeURIComponent(decodedHandle);
      } catch (error) {
        // Keep the raw handle if it is not valid percent-encoding.
      }
      const cacheKey = decodedHandle;
      window.AnasComparePriceCache = window.AnasComparePriceCache || Object.create(null);
      let cacheEntry = window.AnasComparePriceCache[cacheKey];

      if (!cacheEntry || !cacheEntry.promise || saleCheckNow - Number(cacheEntry.fetchedAt || 0) > 15000) {
        const productUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') +
          'products/' + encodeURIComponent(cacheKey) + '.js?anas_sale_check=' + saleCheckNow;

        cacheEntry = {
          fetchedAt: saleCheckNow,
          promise: fetch(productUrl, {
            headers: { 'Accept': 'application/json' },
            cache: 'no-store'
          }).then((response) => response.ok ? response.json() : null).catch(() => null)
        };
        window.AnasComparePriceCache[cacheKey] = cacheEntry;
      }

      cacheEntry.promise.then((product) => {
        // Ignore a response if this item was removed or a newer sale check began.
        if (!this.items.includes(item) || item._comparePriceRequestToken !== requestToken) return;
        if (!product || !Array.isArray(product.variants)) {
          item._comparePriceChecked = false;
          return;
        }

        // ANAS_CART_PERISHABLE_TAG_DETECTION_V1
        // Perishable status is read from Shopify product tags as well as the private cart property,
        // so the warning works for items added through different storefront flows.
        const productTags = Array.isArray(product.tags)
          ? product.tags
          : String(product.tags || '').split(',');
        const isTaggedPerishable = productTags.some((tag) => {
          const normalizedTag = String(tag || '')
            .toLowerCase()
            .trim()
            .replace(/ă|â/g, 'a')
            .replace(/î/g, 'i')
            .replace(/ș|ş/g, 's')
            .replace(/ț|ţ/g, 't');
          return normalizedTag.includes('perisabil') ||
            normalizedTag === 'livrare doar in bucuresti' ||
            normalizedTag.includes('refrigerat') ||
            normalizedTag.includes('congelat');
        });
        const hasPerishableCartProperty =
          String(((item.properties || {})._perisabil) || '').toLowerCase() === 'true';
        item.isPerishable = hasPerishableCartProperty || isTaggedPerishable;

        const variant = product.variants.find((candidate) => String(candidate.id) === String(item.variantId || item.id));
        if (!variant) {
          item._comparePriceChecked = false;
          if (typeof setupPerishableDeliveryCheck === 'function') setupPerishableDeliveryCheck();
          this.renderDrawer();
          return;
        }

        const variantPrice = Number(variant.price || 0) / 100;
        const compareAtPrice = Number(variant.compare_at_price || 0) / 100;

        item.compareAtPrice = compareAtPrice;
        item.isOnSale = compareAtPrice > variantPrice;
        item.originalPrice = item.isOnSale ? compareAtPrice : Number(item.price || variantPrice);
        if (typeof setupPerishableDeliveryCheck === 'function') setupPerishableDeliveryCheck();
        this.renderDrawer();
      });
    });

    itemsEl.innerHTML = this.items.map((item) => {
      const itemProperties = item.properties || {};
      const isPerishableLine = item.isPerishable === true ||
        String(itemProperties._perisabil || '').toLowerCase() === 'true';
      const perishableWarningHtml = isPerishableLine
        ? '<div class="cart-item-perishable-warning" role="note"><span class="cart-item-perishable-warning__icon" aria-hidden="true">⚠️</span><span>Livrare exclusiv în București</span></div>'
        : '';
      let propsHtml = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          const value = item.properties[key];
          if (key.indexOf('_') === 0 || value === null || value === '') return;

          // Indicatorul privat _perisabil este setat doar la produsele marcate ca perisabile.
          // Ascundem avertizarea de livrare pentru orice linie fără acest indicator.
          const normalizedPropertyName = String(key).toLowerCase();
          // Delivery restrictions are rendered as a dedicated warning card below product metadata.
          if (/livrare|delivery/.test(normalizedPropertyName)) return;

          const propertyClass = /livrare|delivery/.test(normalizedPropertyName)
            ? ' cart-item-property--delivery'
            : /preparare|preparation|prep/.test(normalizedPropertyName)
              ? ' cart-item-property--prep'
              : '';

          propsHtml += '<div class="cart-item-property' + propertyClass + '">' +
            '<span class="cart-item-property-label">' + key + '</span>' +
            '<span class="cart-item-property-value">' + value + '</span>' +
            '</div>';
        });
      }

      return `
      <div class="cart-item" data-item-id="${item.id}">
        <div class="cart-item-img">
          <img src="${item.image || ''}" alt="${item.title || ''}" loading="lazy">
        </div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.title || ''}</div>
          <div class="cart-item-meta">
            ${item.isOnSale ? '<span class="anas-cart-sale-badge" aria-label="Produs la reducere">SALE</span>' : ''}
            <div class="cart-item-brand">${item.vendor || ''}</div>
          </div>
          ${perishableWarningHtml}
          <div class="cart-item-options">${propsHtml}</div>
          <div class="cart-item-footer">
            <span class="cart-item-price">${item.isOnSale ? '<s class="anas-cart-sale-old-price">' + item.originalPrice.toFixed(0) + ' RON</s><span class="anas-cart-sale-current">' + item.price.toFixed(0) + ' RON</span>' : '<span class="anas-cart-sale-current">' + item.price.toFixed(0) + ' RON</span>'}</span>
            <div class="qty-control">
              <button type="button" class="qty-btn" aria-label="Scade cantitatea" onclick="AnasCart.changeQuantityBy('${item.id}', -1)">−</button>
              <span class="qty-num" aria-live="polite">${item.quantity}</span>
              <button type="button" class="qty-btn" aria-label="Mărește cantitatea" onclick="AnasCart.changeQuantityBy('${item.id}', 1)">+</button>
            </div>
          </div>
        </div>
      </div>`;
    }).join('');

    if (subtotalEl) subtotalEl.textContent = this.getTotal().toFixed(0) + ' RON';
  }
};

function showToast(message, type = 'success') {


  const container = document.getElementById('toast-container');

  if (!container) return;

  const icons = {
    success:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>',

    info:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="14" height="14"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',

    error:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="14" height="14"><circle cx="12" cy="12" r="9"/><line x1="9" y1="9" x2="15" y2="15"/><line x1="15" y1="9" x2="9" y2="15"/></svg>'
  };

  container.querySelectorAll('.toast').forEach(t => t.remove());

  const toast = document.createElement('div');

  toast.className = 'toast ' + type;

  toast.innerHTML =
    (icons[type] || icons.success) +
    '<span>' + message + '</span>';

  container.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('toast-out');

    setTimeout(() => {
      toast.remove();
    }, 300);
  }, 2200);
}

// Scroll locking centralizat: păstrează exact poziția paginii în spatele drawer-urilor.
window.AnasScrollLock = window.AnasScrollLock || (function () {
  var locked = false;
  var savedY = 0;
  var savedStyles = null;
  var releaseTimer = null;

  function hasOpenLayer() {
    return !!document.querySelector(
      '.cart-drawer.open, #wishlist-drawer.open, #weight-modal.open, #prep-modal.open'
    );
  }

  function lock() {
    if (releaseTimer) {
      clearTimeout(releaseTimer);
      releaseTimer = null;
    }
    if (locked) return;

    var body = document.body;
    var root = document.documentElement;
    savedY = window.scrollY || window.pageYOffset || 0;
    savedStyles = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight,
      rootOverflow: root.style.overflow,
      scrollBehavior: root.style.scrollBehavior
    };

    var scrollbarGap = Math.max(0, window.innerWidth - root.clientWidth);
    var computedPadding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;

    body.style.position = 'fixed';
    body.style.top = '-' + savedY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = 'auto';
    body.style.overflow = 'hidden';
    if (scrollbarGap > 0) body.style.paddingRight = (computedPadding + scrollbarGap) + 'px';
    root.style.overflow = 'hidden';
    locked = true;
  }

  function unlockAfter(delay) {
    if (releaseTimer) clearTimeout(releaseTimer);
    releaseTimer = setTimeout(function () {
      releaseTimer = null;
      if (!locked || hasOpenLayer()) return;

      var body = document.body;
      var root = document.documentElement;
      var y = savedY;
      var styles = savedStyles || {};

      body.style.position = styles.position || '';
      body.style.top = styles.top || '';
      body.style.left = styles.left || '';
      body.style.right = styles.right || '';
      body.style.width = styles.width || '';
      body.style.overflow = styles.overflow || '';
      body.style.paddingRight = styles.paddingRight || '';
      root.style.overflow = styles.rootOverflow || '';
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      requestAnimationFrame(function () {
        root.style.scrollBehavior = styles.scrollBehavior || '';
      });

      locked = false;
      savedStyles = null;
    }, typeof delay === 'number' ? delay : 430);
  }

  return { lock: lock, unlockAfter: unlockAfter };
})();

// ============================================
// CART DRAWER
// ============================================
function openCart() {
  document.getElementById('cart-overlay')?.classList.add('open');
  document.getElementById('cart-drawer')?.classList.add('open');
  window.AnasScrollLock.lock();

  // SALE badges follow the current Shopify compare-at price each time the cart opens.
  if (typeof AnasCart !== 'undefined' && typeof AnasCart.refreshSaleStatuses === 'function') {
    AnasCart.refreshSaleStatuses();
  }

  // Redăm doar o celebrare programată de o trecere reală sub->peste 100 RON.
  // Deschiderea unui coș deja peste prag nu pornește artificiile.
  if (window.__anasPendingMinimumOrderFireworks === true) {
    window.__anasPendingMinimumOrderFireworks = false;
    requestAnimationFrame(function () {
      if (
        isAnasCartDrawerOpen() &&
        !document.querySelector('.anas-cart-page') &&
        Number(AnasCart.getTotal() || 0) >= MINIMUM_ORDER
      ) {
        launchAnasMinimumOrderFireworks();
      }
    });
  }
}

function closeCart() {
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.getElementById('cart-drawer')?.classList.remove('open');
  window.AnasScrollLock.unlockAfter();
}

// ============================================
// TABS
// ============================================
function initTabs() {
  document.querySelectorAll('[data-tab-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('[data-tabs]');
      if (!group) return;
      
      group.querySelectorAll('[data-tab-btn]').forEach(b => b.classList.remove('active'));
      group.querySelectorAll('[data-tab-panel]').forEach(p => p.classList.remove('active'));
      
      btn.classList.add('active');
      const target = btn.dataset.tabBtn;
      group.querySelector(`[data-tab-panel="${target}"]`)?.classList.add('active');
    });
  });
}

// ============================================
// ADD TO CART
// ============================================
/* ANAS_STOCK_GUARD_V1 */
async function anasVariantHasStock(variantId, productHandle, fallbackManaged, fallbackQuantity) {
  var fallbackHasQuantity = fallbackManaged === true &&
    fallbackQuantity !== null && fallbackQuantity !== undefined &&
    fallbackQuantity !== '' && Number.isFinite(Number(fallbackQuantity));
  var fallbackQty = fallbackHasQuantity ? Number(fallbackQuantity) : null;
  if (productHandle && window.Shopify && window.Shopify.routes) {
    try {
      var root = window.Shopify.routes.root || '/';
      var response = await fetch(root + 'products/' + encodeURIComponent(productHandle) +
        '.js?_anas_stock_check=' + Date.now(), {
          method: 'GET',
          cache: 'no-store',
          headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
        });
      if (response.ok) {
        var product = await response.json();
        var variant = (product.variants || []).find(function (candidate) {
          return String(candidate.id) === String(variantId);
        });
        if (variant) {
          if (variant.inventory_management === 'shopify' &&
              variant.inventory_quantity !== null && variant.inventory_quantity !== undefined &&
              variant.inventory_quantity !== '') {
            var freshQuantity = Number(variant.inventory_quantity);
            if (Number.isFinite(freshQuantity)) return freshQuantity > 0;
          }
          // Dacă API-ul nu trimite inventarul, păstrăm cantitatea cunoscută din Liquid.
          if (fallbackHasQuantity) return fallbackQty > 0;
          if (typeof variant.available === 'boolean') return variant.available;
        }
      }
    } catch (error) {
      console.warn('Nu am putut reverifica stocul live:', error);
    }
  }
  if (fallbackHasQuantity) return fallbackQty > 0;
  return null;
}
window.anasVariantHasStock = anasVariantHasStock;

function anasBlockOutOfStock(btn){
  var c=btn&&btn.closest('[data-product]');
  if(!c)return false;
  var force=c.getAttribute('data-anas-force-out-of-stock')==='true';
  var managed=c.getAttribute('data-variant-inventory-managed')==='true';
  var qtyRaw=c.getAttribute('data-variant-inventory-quantity');
  var zero=managed&&qtyRaw!==null&&qtyRaw!==''&&Number(qtyRaw)<=0;
  if(!force&&!zero)return false;
  if(btn){btn.disabled=true;btn.setAttribute('aria-disabled','true');}
  if(typeof showToast==='function')showToast('Stoc epuizat. Produsul nu poate fi adăugat în coș.','error');
  return true;
}
async function addToCart(btn){if(anasBlockOutOfStock(btn))return;
  const card = btn?.closest('[data-product]');

  if (!card) {
    console.error('Add to cart: product card not found');
    showToast('Produsul nu a putut fi identificat.', 'error');
    return;
  }

  const variantId = card.dataset.variantId || card.dataset.productId;
  const title = card.dataset.productTitle || 'Produs';
  const isPerisabil = card.dataset.productPerisabil === 'true';

  if (!variantId) {
    console.error('Add to cart: variant ID missing', card);
    showToast('Varianta produsului nu a fost găsită.', 'error');
    return;
  }

  btn.disabled = true;

  try {
    const stockAvailable = await anasVariantHasStock(
      variantId,
      card.dataset.productHandle || '',
      card.dataset.variantInventoryManaged === 'true',
      card.dataset.variantInventoryQuantity
    );
    if (stockAvailable === false) {
      showToast('Stoc epuizat. Produsul nu poate fi adăugat în coș.', 'error');
      return;
    }

    const properties = isPerisabil
  ? {
      _perisabil: 'true',
      '⚠️ Livrare': 'Doar în București'
    }
  : {};

    const response = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('Shopify cart error:', data);

      throw new Error(
        data?.description ||
        data?.message ||
        'Eroare Shopify'
      );
    }

    const refreshedCart = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/') + 'cart.js?_anas_after_add=' + Date.now(), {
      method: 'GET',
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    }).then(function (cartResponse) {
      if (!cartResponse.ok) throw new Error('Nu am putut actualiza coșul după adăugare.');
      return cartResponse.json();
    });
    const addedVariantId = String(variantId);
    const isPresent = Array.isArray(refreshedCart.items) && refreshedCart.items.some(function (item) {
      return String(item.variant_id || item.id) === addedVariantId;
    });
    if (!isPresent) {
      throw new Error('Shopify nu a confirmat produsul în coș. Încearcă din nou.');
    }
    /* Apply the confirmed Shopify snapshot directly; loadFromShopify may skip UI updates
       while a quantity mutation is pending, which can leave the drawer looking empty. */
    AnasCart._loadSequence += 1;
    AnasCart._applyCartSnapshot(refreshedCart);
    AnasCart.updateUI();
    openCart();
    showToast('Adăugat în coș', 'cart');

    btn.style.transform = 'scale(1.3)';

    setTimeout(() => {
      btn.style.transform = '';
    }, 100);

  } catch (error) {
    console.error('Add to cart error:', error);

    showToast(
      error.message || 'Eroare la adăugare. Încearcă din nou.',
      'error'
    );

  } finally {
    btn.disabled = false;
  }
}

// ============================================
// INIT
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  AnasCart.loadFromShopify()
    .then(function () {
      // Stabilim totalul inițial din Shopify ca bază; nu celebrăm un coș restaurat.
      window.__anasDrawerPreviousTotal = Math.max(0, Number(AnasCart.getTotal() || 0));
      window.__anasMinimumOrderBaselineReady = true;
      window.__anasPendingMinimumOrderFireworks = false;
    })
    .catch(function () {
      // Dacă sincronizarea eșuează, blocăm celebrările bazate pe o stare incertă.
      window.__anasDrawerPreviousTotal = Math.max(0, Number(AnasCart.getTotal() || 0));
      window.__anasMinimumOrderBaselineReady = true;
      window.__anasPendingMinimumOrderFireworks = false;
    });
  AnasWishlist.load();
AnasWishlist.updateUI();

/* ANAS_WISHLIST_GLOBAL_HEART_STATE_SYNC_V3
 * Keep every visible heart in sync, including dynamically inserted collection cards and other tabs.
 */
(function bindAnasWishlistHeartStateSync() {
  if (window.__anasWishlistHeartSyncBound) return;
  window.__anasWishlistHeartSyncBound = true;

  var heartSelector = '.product-wishlist-btn, .product-page-wishlist-btn, [data-anas-wishlist-trigger], [onclick*="toggleWishlist("], [onclick*="toggleProductPageWishlist("]';
  var pendingFrame = 0;

  function refreshHearts() {
    if (pendingFrame) return;
    pendingFrame = window.requestAnimationFrame(function () {
      pendingFrame = 0;
      AnasWishlist.updateUI();
    });
  }

  if (window.MutationObserver && document.body) {
    var observer = new MutationObserver(function (mutations) {
      var hasNewHearts = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          if (!node || node.nodeType !== 1) return false;
          return (node.matches && node.matches(heartSelector)) ||
            (node.querySelector && node.querySelector(heartSelector));
        });
      });
      if (hasNewHearts) refreshHearts();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.__anasWishlistHeartObserver = observer;
  }

  // A wishlist changed in another tab should also refresh this tab.
  window.addEventListener('storage', function (event) {
    if (event.key !== 'anas_wishlist' && event.key !== null) return;
    AnasWishlist.load();
    AnasWishlist.updateUI();
    AnasWishlist.renderDrawer();
  });

  document.addEventListener('anas:wishlist:changed', refreshHearts);
  window.addEventListener('pageshow', refreshHearts);
  document.addEventListener('shopify:section:load', refreshHearts);
  document.addEventListener('shopify:section:reorder', refreshHearts);
  refreshHearts();
})();

    initTabs();
  
  // Cart overlay close
  document.getElementById('cart-overlay')?.addEventListener('click', closeCart);
  
  // Escape key closes drawers
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeCart();
      closeWishlist();
    }
  });
  
  // Sticky header shadow — throttled to one update per frame, only on state changes.
  const header = document.querySelector('.site-header');
  if (header) {
    let headerScrollFrame = 0;
    let headerHasShadow = false;
    window.addEventListener('scroll', () => {
      if (headerScrollFrame) return;
      headerScrollFrame = window.requestAnimationFrame(() => {
        headerScrollFrame = 0;
        const nextHasShadow = window.scrollY > 8;
        if (nextHasShadow === headerHasShadow) return;
        headerHasShadow = nextHasShadow;
        header.style.boxShadow = nextHasShadow ? '0 4px 20px rgba(0,0,0,0.4)' : '';
      });
    }, { passive: true });
  }
});

function debounce(fn, ms) {
  let t;
  return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
}

// ============================================
// WISHLIST
// ============================================
/* ANAS_WISHLIST_HEART_SYNC_V2
 * Normalize product handles so every rendered card and the product page share one saved state.
 */
function normalizeWishlistProductHandle(value) {
  var handle = String(value || '').trim().toLowerCase();
  handle = handle.replace(/^https?:\/\/[^/]+/, '');
  handle = handle.split(/[?#]/, 1)[0];
  handle = handle.replace(/^\/+/, '');
  handle = handle.replace(/^(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//, '');
  return handle.replace(/\/+$/, '');
}

function normalizeWishlistProductTitle(value) {
  return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

function normalizeWishlistProductImage(value) {
  var image = String(value || '').trim().toLowerCase().split(/[?#]/, 1)[0];
  image = image.replace(/^https?:\/\/[^/]+/, '');
  image = image.replace(/_(?:\d+x\d*|small|medium|large|master)(?=\.[a-z0-9]+$)/i, '');
  return image;
}

/* Matches legacy entries only when an authoritative handle is missing.
   If both handles exist, never merge two distinct products just because names match. */
function sameWishlistProduct(a, b) {
  if (!a || !b) return false;

  var aId = String(a.id || '');
  var bId = String(b.id || '');
  if (aId && bId && aId === bId) return true;

  var aHandle = normalizeWishlistProductHandle(a.handle);
  var bHandle = normalizeWishlistProductHandle(b.handle);
  if (aHandle && bHandle) return aHandle === bHandle;

  var aTitle = normalizeWishlistProductTitle(a.title);
  var bTitle = normalizeWishlistProductTitle(b.title);
  var aVendor = normalizeWishlistProductTitle(a.vendor);
  var bVendor = normalizeWishlistProductTitle(b.vendor);
  if (aTitle && bTitle && aTitle === bTitle && aVendor && bVendor && aVendor === bVendor) {
    return true;
  }

  var aImage = normalizeWishlistProductImage(a.image);
  var bImage = normalizeWishlistProductImage(b.image);
  return !!(aTitle && bTitle && aTitle === bTitle && aImage && bImage && aImage === bImage);
}

const AnasWishlist = {
  items: [],

  has(id, handle) {
    const key = String(id || '');
    const targetHandle = normalizeWishlistProductHandle(handle);

    return this.items.some(item => {
      if (key && String(item.id) === key) return true;
      if (!targetHandle) return false;
      return normalizeWishlistProductHandle(item.handle) === targetHandle;
    });
  },

  toggle(product) {
    const id = String(product.id);
    const hasTrackedQuantity = product && product.inventoryManaged === true &&
      product.inventoryQuantity !== null && product.inventoryQuantity !== undefined &&
      product.inventoryQuantity !== '' && Number.isFinite(Number(product.inventoryQuantity));
    const zeroStock = hasTrackedQuantity && Number(product.inventoryQuantity) <= 0;
    const positiveStock = hasTrackedQuantity && Number(product.inventoryQuantity) > 0;
    const genuinelyUnavailable = product && product.available === false && !positiveStock && !zeroStock;
    if (product && (product.forceOutOfStock === true || genuinelyUnavailable || zeroStock) && !this.has(id, product.handle)) {
      showToast('Stoc epuizat. Produsul nu poate fi adăugat în wishlist sau în coș.', 'error');
      return;
    }

    if (this.has(id, product.handle)) {
      this.items = this.items.filter(item => !sameWishlistProduct(item, product));

      showToast('Eliminat din Wishlist', 'info');

    } else {

      this.items.push({
        id: id,
        title: product.title || 'Produs',
        price: Number(product.price || 0),
        compareAtPrice: Number(product.compareAtPrice || 0),
        isOnSale: Number(product.compareAtPrice || 0) > Number(product.price || 0),
        originalPrice: Number(product.compareAtPrice || 0) > Number(product.price || 0)
          ? Number(product.compareAtPrice || 0)
          : Number(product.price || 0),
        vendor: product.vendor || '',
        image: product.image || '',
        handle: product.handle || '',
        available: typeof product.available === 'boolean' ? product.available : null,
        forceOutOfStock: false,
        inventoryManaged: product.inventoryManaged === true,
        inventoryQuantity: product.inventoryQuantity === null || product.inventoryQuantity === undefined || product.inventoryQuantity === '' ? null : Number(product.inventoryQuantity),
        inventoryPolicy: product.inventoryPolicy || 'deny'
      });

      showToast('Adăugat în Wishlist', 'wish');
    }

    this.save();
    this.updateUI();
    this.renderDrawer();
    document.dispatchEvent(new CustomEvent('anas:wishlist:changed', {
      detail: { count: this.items.length }
    }));
  },

  save() {
    try {
      localStorage.setItem(
        'anas_wishlist',
        JSON.stringify(this.items)
      );
    } catch (e) {
      console.error('Wishlist save error:', e);
    }
  },

  load() {
    try {

      const saved =
        localStorage.getItem('anas_wishlist');

      if (!saved) {
        this.items = [];
        return;
      }

      const parsed = JSON.parse(saved);

      this.items = Array.isArray(parsed)
        ? parsed.map(item => ({
            ...item,
            id: String(item.id),
            price: Number(item.price || 0),
            handle: item.handle || '',
            /*
             * Starea de disponibilitate salvată anterior putea proveni din
             * regula greșită de inventory management. O reverificăm la Shopify
             * pentru fiecare produs la prima deschidere a wishlist-ului.
             */
            available: null,
            forceOutOfStock: false,
            inventoryManaged: item.inventoryManaged === true,
            inventoryQuantity: item.inventoryQuantity === null || item.inventoryQuantity === undefined || item.inventoryQuantity === '' ? null : Number(item.inventoryQuantity),
            inventoryPolicy: item.inventoryPolicy || 'deny'
          }))
        : [];

    } catch (e) {

      console.error(
        'Wishlist load error:',
        e
      );

      this.items = [];
    }
  },

  updateUI() {
    const count = this.items.length;
    let needsSave = false;

    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    // One source of truth for product cards, collection grids, carousels and product pages.
    const heartSelector = '.product-wishlist-btn, .product-page-wishlist-btn, [data-anas-wishlist-trigger], [onclick*="toggleWishlist("], [onclick*="toggleProductPageWishlist("]';
    document.querySelectorAll(heartSelector).forEach(btn => {
      const card = btn.closest('[data-product], .product-card, .offers-product-card, .related-products-slide');
      const id = btn.dataset.variantId ||
        btn.dataset.productId ||
        (card && (card.dataset.variantId || card.dataset.productId)) ||
        '';
      const handle = btn.dataset.productHandle ||
        (card && card.dataset.productHandle) ||
        '';

      // Older saved entries may not have a handle. Learn it from a matching visible heart.
      if (id && handle) {
        const exactSavedItem = this.items.find(item => String(item.id) === String(id));
        if (exactSavedItem && !normalizeWishlistProductHandle(exactSavedItem.handle)) {
          exactSavedItem.handle = handle;
          needsSave = true;
        }
      }

      const active = this.has(id, handle);
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-label', active
        ? 'Elimină din wishlist'
        : 'Adaugă în wishlist');
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');

      // Keep the heart filled consistently, even in custom section/card CSS.
      btn.querySelectorAll('svg path').forEach(function (path) {
        path.style.fill = active ? 'currentColor' : 'none';
        path.style.stroke = 'currentColor';
      });
    });

    if (needsSave) this.save();
  },

syncVariantPrice(item, variant) {
    if (!item || !variant || variant.price === null || variant.price === undefined) return;
    const currentPrice = Number(variant.price) / 100;
    if (!Number.isFinite(currentPrice)) return;
    const compareAtPriceRaw = Number(variant.compare_at_price || 0) / 100;
    const compareAtPrice = Number.isFinite(compareAtPriceRaw) ? compareAtPriceRaw : 0;
    item.price = currentPrice;
    item.compareAtPrice = compareAtPrice;
    item.isOnSale = compareAtPrice > currentPrice;
    item.originalPrice = item.isOnSale ? compareAtPrice : currentPrice;
  },

  async checkAvailability(item) {
  try {
    let product = null;

    // ============================================
    // 1. ÎNCERCĂM DIRECT CU HANDLE
    // ============================================
    if (item.handle) {
      const response = await fetch(
        window.Shopify.routes.root +
        'products/' +
        item.handle +
        '.js'
      );

      if (response.ok) {
        product = await response.json();
      }
    }

    // ============================================
    // 2. DACĂ NU AVEM PRODUSUL, ÎL CĂUTĂM DUPĂ TITLU
    // ============================================
    if (!product && item.title) {
      const response = await fetch(
        window.Shopify.routes.root +
        'search/suggest.json?q=' +
        encodeURIComponent(item.title) +
        '&resources[type]=product' +
        '&resources[limit]=10' +
        '&resources[options][unavailable_products]=show'
      );

      if (response.ok) {
        const data = await response.json();

        const products =
          data?.resources?.results?.products || [];

        const wantedTitle =
          String(item.title)
            .trim()
            .toLowerCase();

        let found =
          products.find(
            p =>
              String(p.title)
                .trim()
                .toLowerCase() === wantedTitle
          );

        // Dacă nu găsește titlul exact,
        // luăm primul rezultat relevant
        if (!found && products.length) {
          found = products[0];
        }

        if (found?.handle) {
          item.handle = found.handle;

          const productResponse = await fetch(
            window.Shopify.routes.root +
            'products/' +
            found.handle +
            '.js'
          );

          if (productResponse.ok) {
            product = await productResponse.json();
          }
        }
      }
    }

    // ============================================
    // 3. NU AM GĂSIT PRODUSUL
    // ============================================
    if (!product) {
      console.warn(
        'Wishlist: produs negăsit',
        item.title,
        item.id
      );

      return null;
    }

    const variants = product.variants || [];
    const productTags = Array.isArray(product.tags) ? product.tags : [];
    const productType = String(product.product_type || product.type || '').toLowerCase();
    const isMeatProduct = productType.includes('carne') || productType.includes('meat') || productTags.some(function (tag) {
      const normalizedTag = String(tag || '').toLowerCase().trim();
      return normalizedTag.includes('carne') || normalizedTag === 'meat' || normalizedTag === 'carne-proaspata';
    });
    // Cantitatea zero pe inventar urmărit blochează vânzarea chiar dacă Shopify
    // raportează available=true din cauza politicii "continue selling".
    function readVariantAvailability(candidate) {
      if (candidate && candidate.inventory_management === 'shopify' &&
          candidate.inventory_quantity !== null && candidate.inventory_quantity !== undefined &&
          candidate.inventory_quantity !== '') {
        const quantity = Number(candidate.inventory_quantity);
        item.inventoryManaged = true;
        item.inventoryQuantity = Number.isFinite(quantity) ? quantity : null;
        item.inventoryPolicy = candidate.inventory_policy || item.inventoryPolicy || 'deny';
        if (Number.isFinite(quantity) && quantity <= 0) return false;
        if (Number.isFinite(quantity) && quantity > 0) return true;
      }
      // If Storefront omits inventory fields, use the last confirmed tracked quantity.
      // Fresh inventory fields above always take priority.
      if (item.inventoryManaged === true && item.inventoryQuantity !== null &&
          item.inventoryQuantity !== undefined && item.inventoryQuantity !== '') {
        const savedQuantity = Number(item.inventoryQuantity);
        if (Number.isFinite(savedQuantity)) return savedQuantity > 0;
      }
      if (candidate && typeof candidate.available === 'boolean') return candidate.available;
      return null;
    }
    item.isPerishable = productTags.some(function (tag) {
      const normalizedTag = String(tag || '').toLowerCase().trim();
      return normalizedTag === 'perisabil' ||
        normalizedTag === 'perisabile' ||
        normalizedTag === 'livrare doar in bucurești' ||
        normalizedTag === 'livrare doar in bucuresti';
    });

    if (!variants.length) {
      return null;
    }

    // ============================================
    // 4. ÎNCERCĂM VARIANTA EXACTĂ
    // ============================================
    let variant = variants.find(
      v =>
        String(v.id) ===
        String(item.id)
    );

    // ============================================
    // 5. DACĂ ID-UL DIN WISHLIST ESTE PRODUCT ID
    // ============================================
    const isProductId =
      String(product.id) ===
      String(item.id);

    if (isProductId) {
      // Pentru un product ID, produsul este disponibil
      // dacă EXISTĂ cel puțin o variantă disponibilă.
      const availableVariant = variants.find(function (candidate) {
        return readVariantAvailability(candidate) === true;
      });

      if (availableVariant) {
        variant = availableVariant;
        item.id = String(availableVariant.id);
      } else {
        const statuses = variants.map(readVariantAvailability);
        const allExplicitlyUnavailable = statuses.length > 0 &&
          statuses.every(function (value) { return value === false; });
        item.available = allExplicitlyUnavailable
          ? false
          : (typeof product.available === 'boolean' ? product.available : null);

        this.syncVariantPrice(item, variants[0]);
        item.handle = product.handle || item.handle || '';
        item.forceOutOfStock = false;
        this.save();
        return item.available;
      }
    }

    // ============================================
    // 6. DACĂ AM GĂSIT VARIANTA
    // ============================================
    if (variant) {
      const resolvedAvailability = readVariantAvailability(variant);
      item.available = resolvedAvailability === null && variants.length === 1 &&
        typeof product.available === 'boolean'
          ? product.available
          : resolvedAvailability;

      this.syncVariantPrice(item, variant);
      item.handle = product.handle || item.handle || '';
      item.forceOutOfStock = false;
      this.save();
      return item.available;
    }

    // ============================================
    // 7. DACĂ NU AM PUTUT IDENTIFICA ID-UL,
    //    VERIFICĂM PRODUSUL LA NIVEL GENERAL
    // ============================================
    const availableVariant =
      variants.find(
        v => v.available === true
      );

    if (availableVariant) {
      item.available = true;
      item.id = String(availableVariant.id);

      this.syncVariantPrice(item, availableVariant);

      item.handle =
        product.handle || item.handle || '';

      this.save();

      return true;
    }

    // Declarăm epuizat doar când Shopify confirmă explicit asta.
    const states = variants.map(readVariantAvailability);
    const allUnavailable = states.length > 0 && states.every(function (value) { return value === false; });
    const anyAvailable = states.some(function (value) { return value === true; });

    if (anyAvailable) {
      const availableVariant = variants.find(function (candidate) { return readVariantAvailability(candidate) === true; });
      if (availableVariant) {
        item.id = String(availableVariant.id);
        item.available = true;
        this.syncVariantPrice(item, availableVariant);
      }
    } else if (allUnavailable) {
      item.available = false;
      this.syncVariantPrice(item, variants[0]);
    } else {
      item.available = typeof product.available === 'boolean' ? product.available : null;
    }

    item.handle = product.handle || item.handle || '';
    item.forceOutOfStock = false;
    this.save();
    return item.available;

  } catch (error) {
    console.error(
      'Wishlist availability error:',
      item.title,
      item.id,
      error
    );

    return null;
  }
},

  async renderDrawer() {
    const renderSequence = (this._renderSequence || 0) + 1;
    this._renderSequence = renderSequence;

    const itemsEl = document.getElementById('wishlist-items');
    const emptyEl = document.getElementById('wishlist-empty');
    const footerEl = document.getElementById('wishlist-footer');
    if (!itemsEl) return;

    const currentItems = this.items.slice();

    if (currentItems.length === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) {
        emptyEl.style.setProperty('display', 'flex', 'important');
        emptyEl.setAttribute('aria-hidden', 'false');
      }
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (emptyEl) {
      emptyEl.style.setProperty('display', 'none', 'important');
      emptyEl.setAttribute('aria-hidden', 'true');
    }
    if (footerEl) footerEl.style.display = 'block';

    // ANAS_WISHLIST_AUTO_SALE_REFRESH_V2: force-refresh once on drawer open/periodic refresh; async rerenders stay throttled.
    const forceSalePriceRefresh = !!this._forceSalePriceRefresh;
    this._forceSalePriceRefresh = false;

    // ANAS_WISHLIST_LIVE_SALE_PRICES_V1: refresh current/compare-at prices from Shopify product JSON.
    // Rechecks on drawer opens, so SALE disappears when compare_at_price is removed.
    currentItems.forEach((item) => {
      const now = Date.now();
      if (!item.handle || (!forceSalePriceRefresh && item._salePriceCheckedAt && now - item._salePriceCheckedAt < 30000)) return;
      item._salePriceCheckedAt = now;
      fetch(window.Shopify.routes.root + 'products/' + encodeURIComponent(item.handle) + '.js', {
        headers: { 'Accept': 'application/json' }
      }).then((response) => response.ok ? response.json() : null).then((product) => {
        if (!product || !Array.isArray(product.variants)) return;
        let variant = product.variants.find((candidate) => String(candidate.id) === String(item.id));
        if (!variant && String(product.id) === String(item.id)) {
          variant = product.variants.find((candidate) => candidate.available) || product.variants[0];
          if (variant) item.id = String(variant.id);
        }
        if (!variant) return;
        const oldPrice = Number(variant.compare_at_price || 0) / 100;
        const currentPrice = Number(variant.price || 0) / 100;
        item.price = currentPrice;
        item.compareAtPrice = oldPrice;
        item.isOnSale = oldPrice > currentPrice;
        item.originalPrice = item.isOnSale ? oldPrice : currentPrice;
        item.handle = product.handle || item.handle;
        this.save();
        if (document.getElementById('wishlist-drawer') && this.items.includes(item)) this.renderDrawer();
      }).catch(() => {});
    });

    function cartButtonMarkup(item) {
      const itemHasZeroStock = item.inventoryManaged === true &&
        item.inventoryQuantity !== null && item.inventoryQuantity !== undefined &&
        item.inventoryQuantity !== '' && Number(item.inventoryQuantity) <= 0;
      if (item.available === false || itemHasZeroStock) {
        return `
          <button class="wishlist-out-of-stock" type="button" disabled
            style="display:inline-flex;align-items:center;justify-content:center;width:96px;height:34px;padding:0 10px;border-radius:8px;background:#302d2a;color:#b8860b;border:1px solid rgba(184,134,11,.55);cursor:not-allowed;font-size:9px;font-weight:800;letter-spacing:.7px;white-space:nowrap;line-height:1;box-sizing:border-box;">
            STOC EPUIZAT
          </button>`;
      }

      // Randăm din prima cu clasa finală. Fără transformare ulterioară
      // din .qty-btn într-un buton diferit după o întârziere.
      return `<button class="wishlist-cart-button" type="button"
        onclick="AnasWishlist.moveToCart('${item.id}')">+ COȘ</button>`;
    }

    itemsEl.innerHTML = currentItems.map(item => `
      <div class="cart-item" data-wishlist-item-id="${item.id}">
        <div class="cart-item-img">
          <img src="${item.image || ''}" alt="${item.title || ''}" loading="lazy">
        </div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.title || ''}</div>
          ${item.isOnSale ? '<span class="anas-wishlist-sale-badge">SALE</span>' : ''}
          <div class="cart-item-brand">${item.vendor || ''}</div>
          <div class="cart-item-footer">
            <span class="cart-item-price">${item.isOnSale ? '<s class="anas-wishlist-sale-old-price">' + Number(item.originalPrice || item.compareAtPrice || 0).toFixed(0) + ' RON</s> ' : ''}<span class="anas-wishlist-sale-current">${Number(item.price || 0).toFixed(0)} RON</span></span>
            <div class="wishlist-card-actions">
              ${cartButtonMarkup(item)}
              <button class="wishlist-remove-button" type="button"
                onclick="AnasWishlist.removeItem('${item.id}')"
                aria-label="Elimină" title="Elimină">×</button>
            </div>
          </div>
        </div>
      </div>
    `).join('');

    // Verificăm în fundal doar produsele cu stoc necunoscut. Nu reconstruim
    // toată lista când răspund serverele, deci cardurile nu clipesc și nu
    // revin temporar la stilul vechi.
    const pendingChecks = currentItems
      .filter(item => item.available === null || typeof item.available === 'undefined')
      .map(item => {
        const originalId = String(item.id);
        return this.checkAvailability(item).then(result => ({
          originalId: originalId,
          item: item,
          result: result
        }));
      });

    if (!pendingChecks.length) return;

    const results = await Promise.all(pendingChecks);
    if (renderSequence !== this._renderSequence) return;

    this.save();

    results.forEach(({ originalId, item }) => {
      const card = Array.from(itemsEl.querySelectorAll('[data-wishlist-item-id]'))
        .find(node => node.getAttribute('data-wishlist-item-id') === originalId);
      if (!card) return;

      // checkAvailability poate transforma product ID în variant ID.
      card.setAttribute('data-wishlist-item-id', String(item.id));

      const priceEl = card.querySelector('.cart-item-price');
      if (priceEl) {
        priceEl.innerHTML = item.isOnSale
          ? '<s class="anas-wishlist-sale-old-price">' + Number(item.originalPrice || item.compareAtPrice || 0).toFixed(0) + ' RON</s><span class="anas-wishlist-sale-current">' + Number(item.price || 0).toFixed(0) + ' RON</span>'
          : '<span class="anas-wishlist-sale-current">' + Number(item.price || 0).toFixed(0) + ' RON</span>';
      }

      const actions = card.querySelector('.wishlist-card-actions');
      const currentButton = actions && actions.querySelector('.wishlist-cart-button, .wishlist-out-of-stock');
      if (actions && currentButton) {
        const wantsOutOfStock = item.available === false;
        const isOutOfStockButton = currentButton.classList.contains('wishlist-out-of-stock');

        if (wantsOutOfStock && !isOutOfStockButton) {
          currentButton.outerHTML = cartButtonMarkup(item);
        } else if (!wantsOutOfStock && isOutOfStockButton) {
          currentButton.outerHTML = cartButtonMarkup(item);
        }

        const cartButton = actions.querySelector('.wishlist-cart-button');
        if (cartButton) cartButton.setAttribute('onclick', "AnasWishlist.moveToCart('" + String(item.id) + "')");
        const removeButton = actions.querySelector('.wishlist-remove-button');
        if (removeButton) removeButton.setAttribute('onclick', "AnasWishlist.removeItem('" + String(item.id) + "')");
      }
    });
  },

  removeItem(id) {
    const target = this.items.find(item => String(item.id) === String(id));
    if (!target) return;

    // Curățăm și intrări vechi ale aceluiași produs, inclusiv cele fără handle.
    this.items = this.items.filter(item => !sameWishlistProduct(item, target));

    this.save();
    this.updateUI();
    this.renderDrawer();
    document.dispatchEvent(new CustomEvent('anas:wishlist:changed', {
      detail: { count: this.items.length }
    }));

    // Reconciliem din nou după ce drawer-ul și cardurile au avut un frame să se actualizeze.
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(() => this.updateUI());
    }
  },

  async moveToCart(id) {

    const item =
      this.items.find(
        item =>
          String(item.id) ===
          String(id)
      );

    if (!item) return;

    // Revalidăm disponibilitatea live; un status local vechi nu blochează mutarea.
    const available = await this.checkAvailability(item);

    if (available === false || item.forceOutOfStock === true ||
        (item.inventoryManaged === true && item.inventoryQuantity !== null &&
         item.inventoryQuantity !== undefined && item.inventoryQuantity !== '' &&
         Number(item.inventoryQuantity) <= 0)) {

      showToast(
        'Acest produs nu mai este în stoc.',
        'error'
      );

      this.save();
      this.renderDrawer();

      return;
    }

    // Respectăm aceleași taguri ca butonul principal al produsului:
    // selectare-greutate deschide selectorul de greutate, mod-preparare deschide selectorul de preparare.
    if (item.handle) {
      let productMeta;
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        const metaResponse = await fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js?_anas_wishlist_options=' + Date.now(), {
          method: 'GET',
          cache: 'no-store',
          headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
        });
        if (!metaResponse.ok) throw new Error('Nu am putut verifica opțiunile produsului.');
        productMeta = await metaResponse.json();
      } catch (metadataError) {
        console.error('Wishlist product options error:', metadataError);
        showToast('Nu am putut verifica opțiunile produsului. Încearcă din nou.', 'error');
        return;
      }

      const productTags = Array.isArray(productMeta.tags)
        ? productMeta.tags.map(function(tag) { return String(tag || '').trim().toLowerCase(); })
        : String(productMeta.tags || '').split(',').map(function(tag) { return String(tag || '').trim().toLowerCase(); });
      const hasWeight = productTags.includes('selectare-greutate');
      const hasPrep = productTags.includes('mod-preparare');
      const isPerishable = item.isPerishable === true || productTags.some(function(tag) {
        const normalizedTag = String(tag || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
        return normalizedTag === 'perisabil' || normalizedTag === 'perisabile' ||
          normalizedTag === 'livrare doar in bucuresti';
      });

      if (hasWeight || hasPrep) {
        const productHandle = String(productMeta.handle || item.handle);
        const productTitle = productMeta.title || item.title || 'Produs';
        const productImage = productMeta.featured_image || item.image || '';

        // Pentru produsele cu doar mod de preparare, rezolvăm o variantă disponibilă.
        let prepVariant = null;
        if (!hasWeight && hasPrep) {
          const variants = Array.isArray(productMeta.variants) ? productMeta.variants : [];
          prepVariant = variants.find(function(variant) {
            return String(variant.id) === String(item.variantId || item.id);
          }) || variants.find(function(variant) {
            if (variant.inventory_management === 'shopify' &&
                variant.inventory_quantity !== null && variant.inventory_quantity !== undefined &&
                variant.inventory_quantity !== '') return Number(variant.inventory_quantity) > 0;
            return variant.available === true;
          });
          if (!prepVariant) {
            showToast('Nu am găsit o variantă disponibilă pentru acest produs.', 'error');
            return;
          }
        }

        window.__anasWishlistPendingCartMove = {
          wishlistItemId: String(item.id),
          handle: productHandle,
          createdAt: Date.now()
        };

        // Închidem wishlist-ul înainte de a deschide selectorul existent.
        closeWishlist();
        if (hasWeight) {
          openWeightModal(productHandle, productTitle, productImage, hasPrep, isPerishable);
        } else {
          openPrepModal(
            Number(prepVariant.id),
            productTitle,
            productImage,
            null,
            false,
            isPerishable,
            {
              productHandle: productHandle,
              inventoryManaged: prepVariant.inventory_management === 'shopify' || item.inventoryManaged === true,
              inventoryQuantity: prepVariant.inventory_quantity !== null && prepVariant.inventory_quantity !== undefined && prepVariant.inventory_quantity !== ''
                ? Number(prepVariant.inventory_quantity)
                : item.inventoryQuantity,
              inventoryPolicy: prepVariant.inventory_policy || item.inventoryPolicy || 'deny'
            }
          );
        }
        return;
      }
    }

    try {

      const response =
        await fetch(
          ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/') + 'cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',
              'Accept':
                'application/json'
            },

            body: JSON.stringify({
              id: Number(item.id),
              quantity: 1,
              properties: item.isPerishable ? {
                '_perisabil': 'true',
                '⚠️ Livrare': 'Doar în București'
              } : {}
            })
          }
        );

      const data =
        await response.json();

      if (!response.ok) {

        throw new Error(
          data?.description ||
          data?.message ||
          'Produsul nu mai este disponibil.'
        );
      }

      AnasCart.loadFromShopify();

      this.removeItem(id);

      showToast(
        item.title +
        ' mutat în coș',
        'cart'
      );

      closeWishlist();
      openCart();

    } catch (error) {

      console.error(
        'Wishlist cart error:',
        error
      );

      showToast(
        error.message ||
        'Produsul nu mai este disponibil.',
        'error'
      );

      /*
       * Doar dacă Shopify a refuzat
       * efectiv adăugarea îl marcăm epuizat.
       */
      item.available = false;

      this.save();
      this.renderDrawer();
    }
  }
};
// ============================================
// WISHLIST DRAWER CONTROLS
// ============================================
/* ANAS_WISHLIST_AUTO_SALE_REFRESH_V2: always refresh sale status on open, then recheck while the wishlist stays open. */
function openWishlist() {
  document.getElementById('wishlist-overlay')?.classList.add('open');
  document.getElementById('wishlist-drawer')?.classList.add('open');
  window.AnasScrollLock.lock();
  // Revalidăm statusul de stoc la fiecare deschidere, astfel încât un status
  // vechi din localStorage să nu păstreze în mod fals „Stoc epuizat”.
  AnasWishlist.items.forEach(function (item) {
    item.available = null;
    item.forceOutOfStock = false;
  });
  AnasWishlist.save();
  AnasWishlist._forceSalePriceRefresh = true;
  AnasWishlist.renderDrawer();
  if (AnasWishlist._saleRefreshInterval) clearInterval(AnasWishlist._saleRefreshInterval);
  AnasWishlist._saleRefreshInterval = setInterval(() => {
    const drawer = document.getElementById('wishlist-drawer');
    if (!drawer || !drawer.classList.contains('open')) return;
    AnasWishlist._forceSalePriceRefresh = true;
    AnasWishlist.renderDrawer();
  }, 60000);
}

function closeWishlist() {
  document.getElementById('wishlist-overlay')?.classList.remove('open');
  document.getElementById('wishlist-drawer')?.classList.remove('open');
  if (AnasWishlist._saleRefreshInterval) {
    clearInterval(AnasWishlist._saleRefreshInterval);
    AnasWishlist._saleRefreshInterval = null;
  }
  window.AnasScrollLock.unlockAfter();
}

// ============================================
/* ANAS_WISHLIST_SINGLE_CLICK_NO_AUTOOPEN_GLOBAL_SYNC_V1
 * Single-click toggle, immediate saved heart, no automatic drawer opening,
 * live stock revalidation, and global heart state synchronization.
 */
/* ANAS_WISHLIST_SINGLE_CLICK_PERSISTENT_STATE_V2
 * One synchronous source of truth for all hearts across cards, offers, collections,
 * related products and product pages. Never opens the Wishlist drawer automatically.
 * A background stock request must not silently roll back an already-saved heart.
 */
function anasHandleWishlistHeartClick(btn, clickEvent) {
  if (!btn || typeof AnasWishlist === 'undefined' || !AnasWishlist) return;

  const interactionEvent = clickEvent || window.event;
  if (interactionEvent) {
    window.__anasWishlistHandledEvents = window.__anasWishlistHandledEvents || new WeakSet();
    if (window.__anasWishlistHandledEvents.has(interactionEvent)) return;
    window.__anasWishlistHandledEvents.add(interactionEvent);
    interactionEvent.preventDefault();
    interactionEvent.stopPropagation();
    if (typeof interactionEvent.stopImmediatePropagation === 'function') {
      interactionEvent.stopImmediatePropagation();
    }
  }

  // Product cards differ slightly between regular grids, Special Offers and carousels.
  const candidateSources = [
    btn,
    btn.closest('[data-product]'),
    btn.closest('.product-card'),
    btn.closest('.offers-product-card'),
    btn.closest('.related-products-slide'),
    btn.closest('[data-product-handle]')
  ].filter(function (source, index, list) {
    return !!source && list.indexOf(source) === index;
  });

  const readData = function (key) {
    for (let i = 0; i < candidateSources.length; i += 1) {
      const source = candidateSources[i];
      if (source.dataset && source.dataset[key] !== undefined && source.dataset[key] !== '') {
        return String(source.dataset[key]);
      }
    }
    return '';
  };

  const handle = readData('productHandle');
  const id = readData('variantId') || readData('productId');
  if (!id) {
    console.error('Wishlist: lipsește ID-ul variantei pentru inimă.', btn);
    showToast('Nu am putut identifica produsul. Reîncarcă pagina și încearcă din nou.', 'error');
    return;
  }

  const rawAvailable = readData('productAvailable');
  const rawInventoryQuantity = readData('variantInventoryQuantity');
  const inventoryManaged = readData('variantInventoryManaged') === 'true';
  const inventoryQuantity = rawInventoryQuantity === '' ? null : Number(rawInventoryQuantity);
  const hasTrackedQuantity = inventoryManaged &&
    inventoryQuantity !== null &&
    Number.isFinite(inventoryQuantity);
  const knownZeroStock = hasTrackedQuantity && inventoryQuantity <= 0;
  const forceOutOfStock = readData('anasForceOutOfStock') === 'true';
  const price = parseFloat(readData('wishlistVariantPrice') || readData('productPrice') || 0);
  const compareAtPrice = parseFloat(readData('wishlistCompareAtPrice') || 0);

  const product = {
    id: String(id),
    title: readData('productTitle') || 'Produs',
    price: Number.isFinite(price) ? price : 0,
    compareAtPrice: Number.isFinite(compareAtPrice) ? compareAtPrice : 0,
    vendor: readData('productVendor') || '',
    image: readData('productImage') || '',
    handle: handle,
    // A stale false value is not enough to reject a click; known zero inventory is.
    available: rawAvailable === 'true' ? true : null,
    inventoryManaged: inventoryManaged,
    inventoryQuantity: rawInventoryQuantity === '' ? null : Number(rawInventoryQuantity),
    inventoryPolicy: readData('variantInventoryPolicy') || 'deny',
    forceOutOfStock: forceOutOfStock
  };

  // Removing a saved product is always allowed, even if its stock has changed.
  if (AnasWishlist.has(product.id, product.handle)) {
    AnasWishlist.items = AnasWishlist.items.filter(function (item) {
      return !sameWishlistProduct(item, product);
    });
    showToast('Eliminat din Wishlist', 'info');
  } else {
    if (forceOutOfStock || knownZeroStock) {
      showToast('Stoc epuizat. Produsul nu poate fi adăugat în wishlist.', 'error');
      AnasWishlist.updateUI();
      return;
    }

    AnasWishlist.items.push({
      id: product.id,
      title: product.title,
      price: product.price,
      compareAtPrice: product.compareAtPrice,
      isOnSale: product.compareAtPrice > product.price,
      originalPrice: product.compareAtPrice > product.price ? product.compareAtPrice : product.price,
      vendor: product.vendor,
      image: product.image,
      handle: product.handle,
      available: product.available,
      forceOutOfStock: false,
      inventoryManaged: product.inventoryManaged,
      inventoryQuantity: product.inventoryQuantity,
      inventoryPolicy: product.inventoryPolicy
    });
    showToast('Adăugat în Wishlist', 'wish');
  }

  // Save and synchronize immediately. Updating hidden drawer contents does not open it.
  AnasWishlist.save();
  AnasWishlist.updateUI();
  AnasWishlist.renderDrawer();
  document.dispatchEvent(new CustomEvent('anas:wishlist:changed', {
    detail: { count: AnasWishlist.items.length }
  }));
}
function toggleWishlist(btn, clickEvent) {
  return anasHandleWishlistHeartClick(btn, clickEvent);
}

function toggleProductPageWishlist(btn, clickEvent) {
  return anasHandleWishlistHeartClick(btn, clickEvent);
}

/* ANAS_WISHLIST_WINDOW_EXPORTS_V2
 * Keep legacy integrations compatible, while the delegated handler below works
 * for every dynamically rendered product card and product page.
 */
window.toggleWishlist = toggleWishlist;
window.toggleProductPageWishlist = toggleProductPageWishlist;

/* ANAS_WISHLIST_DELEGATED_CLICK_UNIVERSAL_V2
 * One delegated click path for product cards, special offers, collections,
 * related products and product pages. Wishlist drawer is never auto-opened.
 */
if (!window.__anasWishlistDelegatedClickBound) {
  window.__anasWishlistDelegatedClickBound = true;
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest('.product-wishlist-btn, .product-page-wishlist-btn, [data-anas-wishlist-trigger]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    // The shared handler saves the state, synchronizes every visible heart,
    // and prevents the click from navigating or bubbling into product cards.
    anasHandleWishlistHeartClick(button, event);
  }, true);
}

/* ANAS_WISHLIST_MODAL_HANDOFF_V1
 * Keep a wishlist item until its weight/preparation modal successfully adds it to Shopify.
 */
window.__anasWishlistPendingCartMove = window.__anasWishlistPendingCartMove || null;
window.__anasWishlistModalSubmissionInProgress = false;

function anasClearWishlistPendingCartMove(handle) {
  var pending = window.__anasWishlistPendingCartMove;
  if (!pending) return;
  if (handle && pending.handle && String(handle).toLowerCase() !== String(pending.handle).toLowerCase()) return;
  window.__anasWishlistPendingCartMove = null;
}

function anasCompleteWishlistPendingCartMove(handle) {
  var pending = window.__anasWishlistPendingCartMove;
  if (!pending || !handle) return;
  if (String(handle).toLowerCase() !== String(pending.handle || '').toLowerCase()) return;

  window.__anasWishlistPendingCartMove = null;
  if (typeof AnasWishlist !== 'undefined' && AnasWishlist &&
      Array.isArray(AnasWishlist.items) &&
      AnasWishlist.items.some(function(item) { return String(item.id) === String(pending.wishlistItemId); })) {
    AnasWishlist.removeItem(String(pending.wishlistItemId));
  }
}

// ============================================
// WEIGHT SELECTION MODAL
// ============================================
var _weightModal = {
  handle: null,
  variants: [],
  selectedVariantId: null,
  pricePerKg: 0,
  currentWeight: 1,
  isPerisabil: false
};

function handleAddToCart(btn) {
  if (!btn) return;
  if (anasBlockOutOfStock(btn)) return;

  const hasWeight = btn.dataset.productHasWeight === 'true';
const hasPrep = btn.dataset.productHasPrep === 'true';
const isPerisabil = btn.dataset.productPerisabil === 'true';

  if (hasWeight) {
    const handle = btn.dataset.productHandle;
    const card = btn.closest('[data-product]');

    const title = card ? card.dataset.productTitle : '';
    const img = card ? card.dataset.productImage : '';

    openWeightModal(handle, title, img, hasPrep, isPerisabil);
    return;
  }

  if (hasPrep) {
    const card = btn.closest('[data-product]');

    const variantId = card
      ? (card.dataset.variantId || card.dataset.productId)
      : null;

    const title = card ? card.dataset.productTitle : '';
    const img = card ? card.dataset.productImage : '';

    if (!variantId) {
      console.error('Preparation modal: variant ID missing');
      showToast('Varianta produsului nu a fost găsită.', 'error');
      return;
    }

   openPrepModal(
  Number(variantId),
  title,
  img,
  null,
  false,
  isPerisabil,
  {
    productHandle: card ? card.dataset.productHandle : '',
    inventoryManaged: !!(card && card.dataset.variantInventoryManaged === 'true'),
    inventoryQuantity: card && card.dataset.variantInventoryQuantity !== '' ? Number(card.dataset.variantInventoryQuantity) : null,
    inventoryPolicy: card ? (card.dataset.variantInventoryPolicy || 'deny') : 'deny'
  }
);

    return;
  }

  addToCart(btn);
}
window.addToCart = addToCart;
window.handleAddToCart = handleAddToCart;

function openWeightModal(handle, title, img, hasPrep, isPerisabil) {
  _weightModal.handle = handle;
  _weightModal.hasPrep = hasPrep || false;
  _weightModal.isPerisabil = isPerisabil || false;
  // O nouă deschidere (nu din "Înapoi") -> resetăm selecția salvată anterior
  _weightModal.selectedVariantId = null;
  _weightModal.selectedPrice = null;

  fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      _weightModal.product = product;
      _weightModal.variants = product.variants;
      renderWeightModal(product);
    })
    .catch(function(e) {
      anasClearWishlistPendingCartMove(handle);
      console.error('Weight modal error:', e);
      showToast('Nu am putut încărca opțiunile de greutate. Încearcă din nou.', 'error');
    });
}

// Redesenează modalul de greutate din datele deja încărcate (folosit și la "Înapoi")
function renderWeightModal(product, isStepSwitch) {
  document.getElementById('weight-modal-title').textContent = product.title;
  var imgEl = document.getElementById('weight-modal-img');
  if (product.images && product.images[0]) {
    imgEl.innerHTML = '<img src="' + product.images[0] + '" alt="" width="48" height="48" style="width:100%;height:100%;object-fit:cover;border-radius:8px">';
  }

  // Afișăm doar variantele cu stoc pozitiv. Inventory_quantity=0 prevalează
  // asupra lui available=true când Shopify permite continuarea vânzării.
  var stockVariants = (product.variants || []).filter(function(v) {
    if (v.inventory_management === 'shopify' &&
        v.inventory_quantity !== null && v.inventory_quantity !== undefined &&
        v.inventory_quantity !== '') {
      return Number(v.inventory_quantity) > 0;
    }
    return v.available === true;
  });
  if (!stockVariants.length) {
    showToast('Stoc epuizat. Nu există variante disponibile.', 'error');
    return;
  }

  // Păstrăm varianta selectată anterior dacă ea încă are stoc.
  var selectedId = _weightModal.selectedVariantId;
  var selected = selectedId ? stockVariants.find(function(v) { return v.id == selectedId; }) : null;
  if (!selected) selected = stockVariants[0];

  // Build buttons from in-stock variants — preț fix per variantă
  var quickEl = document.getElementById('weight-modal-quick');
  var html = '';
  stockVariants.forEach(function(v) {
    var isActive = (v.id === selected.id);
    html += '<button class="weight-quick-btn' + (isActive ? ' active' : '') + '" '
      + 'data-variant-id="' + v.id + '" '
      + 'data-price="' + v.price + '" '
      + 'onclick="selectQuickWeight(this)">'
      + v.title
      + '</button>';
  });
  quickEl.innerHTML = html;

  _weightModal.selectedVariantId = selected.id;
  _weightModal.selectedPrice = selected.price;

  document.getElementById('weight-modal-price-per').textContent = Math.round(selected.price / 100) + ' RON';
  updateWeightTotal();

  // Textul butonului: dacă urmează pasul de preparare, nu adăugăm încă în coș
  var confirmBtn = document.getElementById('weight-modal-confirm-btn');
  if (confirmBtn) confirmBtn.textContent = _weightModal.hasPrep ? 'Mod de preparare' : 'Adaugă în coș';

  var modal = document.getElementById('weight-modal');
  var overlay = document.getElementById('weight-modal-overlay');
  var previousOverlay = isStepSwitch ? document.getElementById('prep-modal-overlay') : null;
  if (modal._anasHideTimer) { clearTimeout(modal._anasHideTimer); modal._anasHideTimer = null; }
  if (modal._anasStepInTimer) { clearTimeout(modal._anasStepInTimer); modal._anasStepInTimer = null; }
  if (overlay._anasHideTimer) { clearTimeout(overlay._anasHideTimer); overlay._anasHideTimer = null; }
  if (previousOverlay && previousOverlay._anasHideTimer) { clearTimeout(previousOverlay._anasHideTimer); previousOverlay._anasHideTimer = null; }
  modal.classList.remove('open', 'anas-step-out', 'anas-step-in');
  if (isStepSwitch) modal.classList.add('anas-step-in');
  if (isStepSwitch && previousOverlay && previousOverlay.style.display !== 'none') {
    overlay.style.display = 'block';
    overlay.classList.add('open');
    previousOverlay.classList.remove('open');
    previousOverlay.style.display = 'none';
  } else {
    overlay.classList.remove('open');
    overlay.style.display = 'block';
  }
  modal.style.display = 'flex';
  /* Commit the off-screen start position before toggling .open. */
  void modal.getBoundingClientRect();
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      modal.classList.add('open');
      if (!isStepSwitch) overlay.classList.add('open');
      if (isStepSwitch) {
        modal._anasStepInTimer = setTimeout(function() {
          modal.classList.remove('anas-step-in');
          modal._anasStepInTimer = null;
        }, 230);
      }
    });
  });
  window.AnasScrollLock.lock();
}

function selectQuickWeight(btn) {
  var variant = (_weightModal.variants || []).find(function(v) { return String(v.id) === String(btn.dataset.variantId); });
  if (variant && variant.inventory_management === 'shopify' &&
      variant.inventory_quantity !== null && variant.inventory_quantity !== undefined &&
      Number(variant.inventory_quantity) <= 0) {
    showToast('Stoc epuizat. Alege o variantă cu stoc.', 'error');
    return;
  }
  document.querySelectorAll('.weight-quick-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');

  _weightModal.selectedVariantId = parseInt(btn.dataset.variantId);
  _weightModal.selectedPrice = parseInt(btn.dataset.price);

  document.getElementById('weight-modal-price-per').textContent = Math.round(_weightModal.selectedPrice / 100) + ' RON';
  updateWeightTotal();
}

function weightStep(delta) {} // păstrat pentru compatibilitate

function findClosestVariant(weight) {} // păstrat pentru compatibilitate

function updateWeightTotal() {
  var total = Math.round(_weightModal.selectedPrice / 100);
  var el = document.getElementById('weight-modal-total');
  if (el) el.textContent = total + ' RON';
}

function closeWeightModal(stepSwitch) {
  if (!stepSwitch && !window.__anasWishlistModalSubmissionInProgress) {
    anasClearWishlistPendingCartMove(_weightModal && _weightModal.handle);
  }
  var modal = document.getElementById('weight-modal');
  var overlay = document.getElementById('weight-modal-overlay');
  if (modal) {
    if (modal._anasHideTimer) clearTimeout(modal._anasHideTimer);
    if (modal._anasStepInTimer) clearTimeout(modal._anasStepInTimer);
    modal.classList.remove('anas-step-in');
    if (stepSwitch) modal.classList.add('anas-step-out');
    else modal.classList.remove('anas-step-out');
    modal.classList.remove('open');
    modal._anasHideTimer = setTimeout(function() {
      modal.style.display = 'none';
      modal.classList.remove('anas-step-out', 'anas-step-in');
      modal._anasHideTimer = null;
    }, stepSwitch ? 220 : 190);
  }
  /* Keep the active backdrop during a step switch; the next modal takes it over. */
  if (overlay && !stepSwitch) {
    if (overlay._anasHideTimer) clearTimeout(overlay._anasHideTimer);
    overlay.classList.remove('open');
    overlay._anasHideTimer = setTimeout(function() {
      overlay.style.display = 'none';
      overlay._anasHideTimer = null;
    }, 180);
  }
  window.AnasScrollLock.unlockAfter();
}

async function confirmWeightAdd() {
  if (!_weightModal.selectedVariantId) return;

  var variantId = _weightModal.selectedVariantId;
  var wishlistModalHandle = _weightModal.handle || '';
  var title = document.getElementById('weight-modal-title').textContent;
  var variant = _weightModal.variants.find(function(v) { return v.id == variantId; });
  var weightLabel = variant ? variant.title : '';
  var img = document.getElementById('weight-modal-img').querySelector('img');
  var imgSrc = img ? img.src : '';

  var stockAvailable = await anasVariantHasStock(
    variantId,
    _weightModal.handle,
    !!(variant && variant.inventory_management === 'shopify'),
    variant ? variant.inventory_quantity : null
  );
  if (stockAvailable === false) {
    showToast('Stoc epuizat. Alege o variantă cu stoc.', 'error');
    return;
  }

  window.__anasWishlistModalSubmissionInProgress = true;
  closeWeightModal(!!_weightModal.hasPrep);
  window.__anasWishlistModalSubmissionInProgress = false;

  // Dacă produsul are și mod-preparare, deschidem al doilea popup
  if (_weightModal.hasPrep) {
   openPrepModal(
  variantId,
  title,
  imgSrc,
  weightLabel,
  true,
  _weightModal.isPerisabil,
  {
    productHandle: _weightModal.handle || '',
    inventoryManaged: !!(variant && variant.inventory_management === 'shopify'),
    inventoryQuantity: variant ? variant.inventory_quantity : null,
    inventoryPolicy: variant ? (variant.inventory_policy || 'deny') : 'deny'
  }
);
    return;
  }

  // Altfel adăugăm direct în coș cu greutatea ca proprietate
  fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({
  id: variantId,
  quantity: 1,
  properties: {
  'Greutate': weightLabel,
  ...(_weightModal.isPerisabil
    ? {
        '_perisabil': 'true',
        '⚠️ Livrare': 'Doar în București'
      }
    : {})
}
})
  })
  .then(function(r) {
    if (!r.ok) throw new Error('Cart error ' + r.status);
    return r.json();
  })
 .then(function() {
  anasCompleteWishlistPendingCartMove(wishlistModalHandle);
  AnasCart.loadFromShopify();
  openCart();
  showToast('Adăugat în coș', 'cart');
})
  .catch(function(e) {
    anasClearWishlistPendingCartMove(wishlistModalHandle);
    console.error('Add to cart error:', e);
    showToast('Eroare la adăugare. Încearcă din nou.', 'error');
  });
}

// ============================================
// PREPARATION MODE MODAL
// ============================================
var _prepModal = {
  variantId: null,
  title: null,
  weight: null,
  fromWeight: false,
  selectedMode: null,
  quantity: 1,
  isPerisabil: false,
  productHandle: '',
  inventoryManaged: false,
  inventoryQuantity: null,
  inventoryPolicy: 'deny'
};

function openPrepModal(variantId, title, img, weightLabel, fromWeight, isPerisabil, stockData) {
  var isStepSwitch = !!fromWeight;
  _prepModal.variantId = variantId;
  _prepModal.title = title;
  _prepModal.weight = weightLabel || null;
  _prepModal.fromWeight = !!fromWeight;
  _prepModal.isPerisabil = !!isPerisabil;
  stockData = stockData || {};
  _prepModal.productHandle = stockData.productHandle || '';
  _prepModal.inventoryManaged = stockData.inventoryManaged === true;
  _prepModal.inventoryQuantity = stockData.inventoryQuantity === null || stockData.inventoryQuantity === undefined || stockData.inventoryQuantity === '' ? null : Number(stockData.inventoryQuantity);
  _prepModal.inventoryPolicy = stockData.inventoryPolicy || 'deny';

  document.getElementById('prep-modal-title').textContent = title;
  var subtitle = weightLabel ? weightLabel : 'Alege modul de preparare';
  document.getElementById('prep-modal-subtitle').textContent = subtitle;

  var imgEl = document.getElementById('prep-modal-img');
  if (img) {
    imgEl.innerHTML = '<img src="' + img + '" alt="" width="48" height="48" style="width:100%;height:100%;object-fit:cover;border-radius:8px">';
  }

  // Build buttons from Theme Settings — la fel ca la greutate: alegi, apoi confirmi cu butonul "Adaugă în coș"
  var buttons = window.AH_PREP_BUTTONS || [
    'Fără preferință', 'Cubulețe', 'Felii', 'Tocat',
    'Bucăți mari', 'Bucăți mici', 'File', 'Osos', 'Marinat', 'La cerere'
  ];
  buttons = buttons.filter(function(l) { return !!l; });

  _prepModal.selectedMode = buttons[0] || 'Fără preferință';

  var html = '';
  buttons.forEach(function(label, i) {
    html += '<button class="weight-quick-btn' + (i === 0 ? ' active' : '') + '" '
      + 'data-mode="' + label.replace(/"/g, '&quot;') + '" '
      + 'onclick="selectPrepMode(this)">' + label + '</button>';
  });
  document.getElementById('prep-modal-buttons').innerHTML = html;

  // Butonul "Înapoi" apare doar dacă acest pas vine după alegerea kg-ului
  var backBtn = document.getElementById('prep-modal-back-btn');
  if (backBtn) backBtn.style.display = _prepModal.fromWeight ? '' : 'none';

  var modal = document.getElementById('prep-modal');
  var overlay = document.getElementById('prep-modal-overlay');
  var previousOverlay = isStepSwitch ? document.getElementById('weight-modal-overlay') : null;
  if (modal._anasHideTimer) { clearTimeout(modal._anasHideTimer); modal._anasHideTimer = null; }
  if (modal._anasStepInTimer) { clearTimeout(modal._anasStepInTimer); modal._anasStepInTimer = null; }
  if (overlay._anasHideTimer) { clearTimeout(overlay._anasHideTimer); overlay._anasHideTimer = null; }
  if (previousOverlay && previousOverlay._anasHideTimer) { clearTimeout(previousOverlay._anasHideTimer); previousOverlay._anasHideTimer = null; }
  modal.classList.remove('open', 'anas-step-out', 'anas-step-in');
  if (isStepSwitch) modal.classList.add('anas-step-in');
  if (isStepSwitch && previousOverlay && previousOverlay.style.display !== 'none') {
    overlay.style.display = 'block';
    overlay.classList.add('open');
    previousOverlay.classList.remove('open');
    previousOverlay.style.display = 'none';
  } else {
    overlay.classList.remove('open');
    overlay.style.display = 'block';
  }
  modal.style.display = 'flex';
  /* Commit the off-screen start position before toggling .open. */
  void modal.getBoundingClientRect();
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      modal.classList.add('open');
      if (!isStepSwitch) overlay.classList.add('open');
      if (isStepSwitch) {
        modal._anasStepInTimer = setTimeout(function() {
          modal.classList.remove('anas-step-in');
          modal._anasStepInTimer = null;
        }, 230);
      }
    });
  });
  window.AnasScrollLock.lock();
}

function closePrepModal(stepSwitch) {
  if (!stepSwitch && !window.__anasWishlistModalSubmissionInProgress) {
    anasClearWishlistPendingCartMove(_prepModal && _prepModal.productHandle);
  }
  var modal = document.getElementById('prep-modal');
  var overlay = document.getElementById('prep-modal-overlay');
  if (modal) {
    if (modal._anasHideTimer) clearTimeout(modal._anasHideTimer);
    if (modal._anasStepInTimer) clearTimeout(modal._anasStepInTimer);
    modal.classList.remove('anas-step-in');
    if (stepSwitch) modal.classList.add('anas-step-out');
    else modal.classList.remove('anas-step-out');
    modal.classList.remove('open');
    modal._anasHideTimer = setTimeout(function() {
      modal.style.display = 'none';
      modal.classList.remove('anas-step-out', 'anas-step-in');
      modal._anasHideTimer = null;
    }, stepSwitch ? 220 : 190);
  }
  /* Keep the active backdrop during a step switch; the next modal takes it over. */
  if (overlay && !stepSwitch) {
    if (overlay._anasHideTimer) clearTimeout(overlay._anasHideTimer);
    overlay.classList.remove('open');
    overlay._anasHideTimer = setTimeout(function() {
      overlay.style.display = 'none';
      overlay._anasHideTimer = null;
    }, 180);
  }
  window.AnasScrollLock.unlockAfter();
}

// Buton "Înapoi" din modalul de preparare -> revine la modalul de selectare kg,
// păstrând varianta (kg-ul) aleasă anterior
function backFromPrepModal() {
  closePrepModal(true);
  if (_weightModal.product) {
    renderWeightModal(_weightModal.product, true);
  }
}

// Click pe un buton de mod de preparare -> doar selectează (evidențiază), nu adaugă în coș
function selectPrepMode(btn) {
  document.querySelectorAll('#prep-modal-buttons .weight-quick-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  _prepModal.selectedMode = btn.dataset.mode;
}

// Butonul "Adaugă în coș" din modalul de preparare -> confirmă alegerea și adaugă în coș
async function confirmPrepAdd() {
  var wishlistModalHandle = _prepModal.productHandle || '';
  var stockAvailable = await anasVariantHasStock(
    _prepModal.variantId,
    _prepModal.productHandle,
    _prepModal.inventoryManaged,
    _prepModal.inventoryQuantity
  );
  if (stockAvailable === false) {
    showToast('Stoc epuizat. Produsul nu poate fi adăugat în coș.', 'error');
    return;
  }

  var mode = _prepModal.selectedMode || 'Fără preferință';
  window.__anasWishlistModalSubmissionInProgress = true;
  closePrepModal();
  window.__anasWishlistModalSubmissionInProgress = false;

  var note = _prepModal.title;
  if (_prepModal.weight) note += ' - ' + _prepModal.weight;
  if (mode !== 'Fără preferință') note += ' - ' + mode;

  var properties = {};
  if (mode !== 'Fără preferință') properties['Mod de preparare'] = mode;

  // Add to Shopify cart with note
  fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: _prepModal.variantId,
      quantity: 1,
      properties: {
  ...properties,
  ...(_prepModal.isPerisabil
    ? {
        '_perisabil': 'true',
        '⚠️ Livrare': 'Doar în București'
      }
    : {})
}
    })
  })
  .then(function(r) {
    if (!r.ok) throw new Error('Cart error ' + r.status);
    return r.json();
  })
  .then(function() {
  anasCompleteWishlistPendingCartMove(wishlistModalHandle);
  AnasCart.loadFromShopify();
  openCart();
  showToast('Adăugat în coș', 'cart');
})
  .catch(function(e) {
    anasClearWishlistPendingCartMove(wishlistModalHandle);
    console.error('Cart error:', e);
    showToast('Eroare la adăugare. Încearcă din nou.', 'error');
  });
}
// ============================================
// PERISABILE - RESTRICTIE LIVRARE
// ============================================

function cartHasPerishable() {
  return AnasCart.items.some(function(item) {
    return item.isPerishable === true ||
      String(((item.properties || {})._perisabil) || '').toLowerCase() === 'true';
  });
}

function normalizeCity(city) {
  return city
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

function isBucharest(city) {
  var normalized = normalizeCity(city);

  return (
    normalized === 'bucuresti' ||
    normalized === 'bucharest'
  );
}

function removePerishableProducts() {
  var perishableItems = AnasCart.items.filter(function(item) {
    return item.properties &&
      item.properties._perisabil === 'true';
  });

  if (perishableItems.length === 0) {
    validatePerishableDelivery();
    return;
  }

  var requests = perishableItems.map(function(item) {
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: item.id,
        quantity: 0
      })
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Nu s-a putut elimina produsul.');
      }

      return response.json();
    });
  });

  Promise.all(requests)
    .then(function() {
      return AnasCart.loadFromShopify();
    })
    .then(function() {
      showToast(
        'Produsele perisabile au fost eliminate din coș.',
        'info'
      );
    })
    .catch(function(error) {
      console.error(
        'Remove perishable products error:',
        error
      );

      showToast(
        'Produsele nu au putut fi eliminate. Încearcă din nou.',
        'error'
      );
    });
}

window.removePerishableProducts = removePerishableProducts;


function setupPerishableDeliveryCheck() {
  var cartFooter = document.getElementById('cart-footer');
  if (!cartFooter) return;

  var box = document.getElementById('perishable-delivery-box');
  if (!box) {
    box = document.createElement('div');
    box.id = 'perishable-delivery-box';
    box.innerHTML = `
      <div class="cart-perishable-footer-warning" role="note">
        <span class="cart-perishable-footer-warning__icon" aria-hidden="true">⚠️</span>
        <span>Produsele proaspete, refrigerate și congelate se livrează exclusiv în București.</span>
      </div>
    `;
    cartFooter.prepend(box);
  }

  box.style.display = cartHasPerishable() ? 'block' : 'none';
}

function validatePerishableDelivery() {
  var box = document.getElementById('perishable-delivery-box');
  if (box) box.style.display = cartHasPerishable() ? 'block' : 'none';
}


function disableCheckoutButtons() {
  document.querySelectorAll(
    'a[href*="/checkout"], button[name="checkout"], [data-checkout]'
  ).forEach(function(btn) {
    btn.dataset.perishableBlocked = 'true';
    btn.style.opacity = '0.5';
    btn.style.pointerEvents = 'none';
    btn.setAttribute('aria-disabled', 'true');
  });
}


function enableCheckoutButtons() {
  document.querySelectorAll(
    'a[href*="/checkout"], button[name="checkout"], [data-checkout]'
  ).forEach(function(btn) {

    delete btn.dataset.perishableBlocked;

    if (!btn.dataset.minimumOrderBlocked) {
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
      btn.removeAttribute('aria-disabled');
    }
  });
}


// Checkout-ul nu mai este blocat în pop-up pe baza unui oraș introdus manual.
// Regulile reale de livrare rămân gestionate la checkout-ul Shopify.

// Refacem verificarea după orice actualizare a coșului
const originalUpdateUI = AnasCart.updateUI.bind(AnasCart);

AnasCart.updateUI = function() {
  originalUpdateUI();
  setTimeout(setupPerishableDeliveryCheck, 100);
};

// Inițializare
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(setupPerishableDeliveryCheck, 100);
});
(function () {
  'use strict';
  var params = new URLSearchParams(window.location.search);
  if (params.get('oferte') !== '1') return;

  // Sale filtering is scoped to the product grid; it does not watch the entire site.
  var pendingCards = new Set();
  var filterFrame = 0;
  var observedGrids = new WeakSet();

  function filterCard(card) {
    if (!card || !card.querySelector) return;
    var hasComparePrice = !!card.querySelector('.product-price-original');
    card.style.display = hasComparePrice ? '' : 'none';
  }

  function collectCards(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('.product-card')) pendingCards.add(node);
    if (node.querySelectorAll) {
      node.querySelectorAll('.product-card').forEach(function (card) { pendingCards.add(card); });
    }
  }

  function scheduleFiltering() {
    if (!pendingCards.size || filterFrame) return;
    filterFrame = window.requestAnimationFrame(function () {
      filterFrame = 0;
      var cards = Array.from(pendingCards);
      pendingCards.clear();
      cards.forEach(filterCard);
    });
  }

  function initSaleGridFilter() {
    var grids = document.querySelectorAll(
      '.anas-collection-page .anas-products-grid, .anas-products-grid, .anas-category-products, .products-grid, .product-grid, .collection [class*="products-grid"]'
    );

    if (!grids.length) return;
    var salePage = document.querySelector('.anas-collection-page');
    if (salePage) salePage.classList.add('anas-collection-page--sale');

    grids.forEach(function (grid) {
      grid.querySelectorAll('.product-card').forEach(filterCard);
      if (observedGrids.has(grid)) return;
      observedGrids.add(grid);
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) collectCards(added[j]);
        }
        scheduleFiltering();
      });
      observer.observe(grid, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSaleGridFilter, { once: true });
  } else {
    initSaleGridFilter();
  }
  document.addEventListener('shopify:section:load', initSaleGridFilter);
})();
/* ============================================
   COMANDĂ MINIMĂ - 100 RON
   ============================================ */

const MINIMUM_ORDER = 100;

// Starea pentru artificii: încărcarea inițială a coșului nu este o trecere de prag.
window.__anasMinimumOrderBaselineReady = false;
window.__anasPendingMinimumOrderFireworks = false;

/* Stiluri locale pentru bara premium. Nu modifică dimensiunile drawer-ului. */
function ensureMinimumOrderProgressStyles() {
  /* Actualizăm stilurile existente și în Shopify Theme Editor, unde un style vechi poate rămâne în DOM. */
  const existingStyle = document.getElementById('anas-minimum-order-progress-styles');
  const style = existingStyle || document.createElement('style');
  style.id = 'anas-minimum-order-progress-styles';
  style.textContent = `
    /* Indicator premium compact: titlu, total, bară fină și suma rămasă. */
    #cart-drawer #minimum-order-message {
      display: block !important;
      flex: 0 0 auto !important;
      width: 100% !important;
      margin: 0 0 8px !important;
      padding: 0 !important;
      border: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      box-sizing: border-box !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress,
    #cart-drawer #minimum-order-message .anas-minimum-progress.is-complete {
      display: block !important;
      position: relative !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      box-sizing: border-box !important;
      overflow: visible !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress-head {
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      gap: 8px !important;
      margin: 0 0 6px !important;
      padding: 0 !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress-kicker {
      display: block !important;
      color: #936b32 !important;
      font-size: 9px !important;
      font-weight: 800 !important;
      letter-spacing: .85px !important;
      line-height: 1.2 !important;
      text-transform: uppercase !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress-total {
      display: inline-flex !important;
      flex: 0 0 auto !important;
      align-items: center !important;
      justify-content: center !important;
      min-height: 18px !important;
      padding: 2px 7px !important;
      border: 1px solid rgba(145, 103, 43, .19) !important;
      border-radius: 999px !important;
      background: linear-gradient(180deg, #f2e3c5 0%, #e8d4ad 100%) !important;
      color: #795a2e !important;
      font-size: 9px !important;
      font-weight: 800 !important;
      letter-spacing: .1px !important;
      line-height: 1 !important;
      white-space: nowrap !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress-foot {
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      gap: 8px !important;
      margin: 5px 0 0 !important;
      padding: 5px 0 0 !important;
      border-top: 1px solid rgba(139, 109, 67, .28) !important;
      color: #8b765d !important;
      font-size: 9px !important;
      line-height: 1.25 !important;
      font-weight: 500 !important;
      text-align: left !important;
      white-space: normal !important;
      overflow-wrap: anywhere !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress-label {
      display: block !important;
      flex: 1 1 auto !important;
      color: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress-remaining {
      display: inline-block !important;
      flex: 0 0 auto !important;
      color: #5b4225 !important;
      font-size: 10px !important;
      font-weight: 800 !important;
      line-height: 1.15 !important;
      white-space: nowrap !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress-track {
      display: block !important;
      position: relative !important;
      width: 100% !important;
      height: 6px !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 1px solid rgba(126, 83, 25, .38) !important;
      border-radius: 999px !important;
      background: linear-gradient(180deg, #e2d0ac 0%, #f8efdE 48%, #d7bf94 100%) !important;
      box-shadow: inset 0 1px 2px rgba(67, 43, 17, .22), 0 1px 0 rgba(255, 255, 255, .88), 0 0 6px rgba(176, 129, 50, .10) !important;
      box-sizing: border-box !important;
      overflow: hidden !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress-fill {
      display: block !important;
      position: relative !important;
      width: 0%;
      height: 100% !important;
      border: 0 !important;
      border-radius: inherit !important;
      background: linear-gradient(90deg, #684116 0%, #9f6d25 22%, #d8ae5d 48%, #f7df9c 62%, #c18a35 82%, #88571d 100%) !important;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, .66), 0 0 7px rgba(177, 127, 44, .34) !important;
      transition: width .45s cubic-bezier(.22, .61, .36, 1) !important;
      overflow: hidden !important;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress-fill::after {
      content: '' !important;
      position: absolute !important;
      top: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      width: 28px !important;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,.58) 100%) !important;
      pointer-events: none !important;
    }

    /* Finalizare premium: reflexie aurie la atingerea pragului de 100 RON. */
    #cart-drawer #minimum-order-message .anas-minimum-progress.is-complete .anas-minimum-progress-fill {
      background: linear-gradient(90deg, #657a39 0%, #9cad60 24%, #e2d9a1 52%, #b9c782 76%, #7b9149 100%) !important;
      box-shadow: inset 0 1px 0 rgba(255,255,255,.82), 0 0 10px rgba(161,178,99,.48) !important;
      animation: anasMinimumProgressComplete .95s ease-out 1 both;
    }

    #cart-drawer #minimum-order-message .anas-minimum-progress.is-complete .anas-minimum-progress-fill::after {
      right: auto !important;
      left: -32% !important;
      width: 30% !important;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,.88) 50%, transparent 100%) !important;
      animation: anasMinimumProgressShine 1.05s cubic-bezier(.22,.61,.36,1) 1 both;
    }

    @keyframes anasMinimumProgressComplete {
      0% { filter: brightness(1); box-shadow: inset 0 1px 0 rgba(255,255,255,.66), 0 0 5px rgba(177,127,44,.25); }
      38% { filter: brightness(1.48); box-shadow: inset 0 1px 0 rgba(255,255,255,.95), 0 0 15px rgba(190,207,125,.75); }
      100% { filter: brightness(1); box-shadow: inset 0 1px 0 rgba(255,255,255,.82), 0 0 10px rgba(161,178,99,.48); }
    }

    @keyframes anasMinimumProgressShine {
      0% { left: -32%; opacity: 0; }
      18% { opacity: 1; }
      100% { left: 110%; opacity: 0; }
    }

    /* Butonul indică elegant suma lipsă fără să își schimbe dimensiunile. */
    #cart-drawer .cart-go-button.is-minimum-order-blocked {
      color: #765126 !important;
      border-color: rgba(145, 103, 43, .48) !important;
      background: linear-gradient(180deg, #f6ead4 0%, #ead6b2 100%) !important;
      box-shadow: inset 0 1px 0 rgba(255,255,255,.72), 0 3px 9px rgba(91,64,32,.08) !important;
      cursor: not-allowed !important;
      opacity: 1 !important;
      transform: none !important;
    }

    #cart-drawer .cart-go-button.is-minimum-order-blocked:hover,
    #cart-drawer .cart-go-button.is-minimum-order-blocked:active {
      color: #765126 !important;
      background: linear-gradient(180deg, #f6ead4 0%, #ead6b2 100%) !important;
      box-shadow: inset 0 1px 0 rgba(255,255,255,.72), 0 3px 9px rgba(91,64,32,.08) !important;
      transform: none !important;
    }

    @media (prefers-reduced-motion: reduce) {
      #cart-drawer #minimum-order-message .anas-minimum-progress-fill,
      #cart-drawer #minimum-order-message .anas-minimum-progress-fill::after {
        transition: none !important;
        animation: none !important;
      }
    }
  `;
  if (!existingStyle) document.head.appendChild(style);
}

/* =========================================================
   ARTIFICII PREMIUM — CANVAS OPTIMIZAT
   Se declanșează doar la trecerea pragului de 100 RON.
   ========================================================= */
function isAnasCartDrawerOpen() {
  const drawer = document.getElementById('cart-drawer');
  return !!(drawer && (
    drawer.classList.contains('open') ||
    drawer.classList.contains('active') ||
    drawer.classList.contains('is-open')
  ));
}

function launchAnasMinimumOrderFireworks() {
  if (!isAnasCartDrawerOpen() && !document.querySelector('.anas-cart-page')) return false;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
  if (!document.body || document.hidden) return false;

  const stateKey = '__anasMinimumOrderFireworksState';
  const state = window[stateKey] || { raf: 0, layer: null, lastFrame: 0 };
  window[stateKey] = state;

  // Nu suprapunem animații și canvas-uri.
  if (state.raf) cancelAnimationFrame(state.raf);
  if (state.layer && state.layer.parentNode) state.layer.remove();
  state.raf = 0;
  state.layer = null;
  state.lastFrame = 0;

  // Detectăm automat conexiunile și dispozitivele mai lente.
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const slowConnection = !!(connection && (
    connection.saveData === true ||
    /^(slow-2g|2g)$/.test(connection.effectiveType || '') ||
    Number(connection.rtt || 0) > 500
  ));
  const lowMemory = typeof navigator.deviceMemory === 'number' && navigator.deviceMemory <= 2;
  const lowCpu = typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency <= 4;
  const lowPerformance = slowConnection || lowMemory || lowCpu;

  const width = Math.max(1, window.innerWidth || document.documentElement.clientWidth || 1);
  const height = Math.max(1, window.innerHeight || document.documentElement.clientHeight || 1);
  const requestedScale = Math.min(window.devicePixelRatio || 1, lowPerformance ? 0.75 : 1);
  const scale = Math.min(requestedScale, 1600 / Math.max(width, height));
  const particlesPerBurst = lowPerformance ? 16 : 26;
  const durationMs = lowPerformance ? 1350 : 1650;

  let style = document.getElementById('anas-minimum-order-fireworks-style');
  if (!style) {
    style = document.createElement('style');
    style.id = 'anas-minimum-order-fireworks-style';
    style.textContent = `
      #anas-minimum-order-fireworks {
        position: fixed !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        overflow: hidden !important;
        pointer-events: none !important;
        z-index: 2147483647 !important;
        contain: strict !important;
        isolation: isolate !important;
      }
      #anas-minimum-order-fireworks canvas {
        display: block !important;
        width: 100% !important;
        height: 100% !important;
        pointer-events: none !important;
      }
      @media (prefers-reduced-motion: reduce) {
        #anas-minimum-order-fireworks { display: none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  const legacyStyle = document.getElementById('anas-minimum-order-confetti-style');
  if (legacyStyle && legacyStyle !== style) legacyStyle.remove();

  const layer = document.createElement('div');
  layer.id = 'anas-minimum-order-fireworks';
  layer.setAttribute('aria-hidden', 'true');
  layer.setAttribute('role', 'presentation');

  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(width * scale));
  canvas.height = Math.max(1, Math.round(height * scale));
  layer.appendChild(canvas);

  let ctx = null;
  try { ctx = canvas.getContext('2d', { alpha: true }); } catch (error) { ctx = null; }
  if (!ctx) {
    layer.remove();
    return false;
  }

  ctx.scale(scale, scale);
  document.body.appendChild(layer);
  state.layer = layer;

  const colors = ['#C99A48', '#E8C986', '#FFF0C9', '#FFFFFF', '#AEBB79'];
  const bursts = [
    { x: width * 0.26, y: height * 0.31, delay: 0 },
    { x: width * 0.74, y: height * 0.32, delay: 135 },
    { x: width * 0.50, y: height * 0.23, delay: 270 }
  ];
  const particles = [];

  bursts.forEach(function (burst, burstIndex) {
    for (let i = 0; i < particlesPerBurst; i += 1) {
      const angle = (Math.PI * 2 * i / particlesPerBurst) + (Math.random() * 0.18);
      const speed = (lowPerformance ? 1.8 : 2.25) + Math.random() * (lowPerformance ? 1.8 : 2.7);
      particles.push({
        x: burst.x,
        y: burst.y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        gravity: 0.028 + Math.random() * 0.025,
        delay: burst.delay + Math.random() * 45,
        age: 0,
        life: (lowPerformance ? 30 : 37) + Math.random() * (lowPerformance ? 10 : 14),
        size: (lowPerformance ? 1.45 : 1.7) + Math.random() * (lowPerformance ? 1.25 : 1.7),
        color: colors[(i + burstIndex * 2) % colors.length]
      });
    }
  });

  const startedAt = performance.now();

  function finish() {
    if (state.raf) cancelAnimationFrame(state.raf);
    state.raf = 0;
    if (layer.parentNode) layer.remove();
    if (state.layer === layer) state.layer = null;
  }

  function draw(now) {
    if (!layer.isConnected || document.hidden ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      finish();
      return;
    }

    if (lowPerformance && state.lastFrame && now - state.lastFrame < 32) {
      state.raf = requestAnimationFrame(draw);
      return;
    }
    state.lastFrame = now;

    if (now - startedAt >= durationMs) {
      finish();
      return;
    }

    ctx.clearRect(0, 0, width, height);
    let activeParticles = 0;
    const elapsed = now - startedAt;

    // Inele luminoase în expansiune: artificiile par mai mari fără blur costisitor.
    bursts.forEach(function (burst, index) {
      const ringProgress = Math.max(0, Math.min(1, (elapsed - burst.delay) / 430));
      if (ringProgress <= 0 || ringProgress >= 1) return;
      const radius = ringProgress * (lowPerformance ? 42 : 61);
      ctx.globalAlpha = (1 - ringProgress) * 0.82;
      ctx.strokeStyle = index === 1 ? '#FFF0C9' : '#D6AD60';
      ctx.lineWidth = lowPerformance ? 1.4 : 1.9;
      ctx.beginPath();
      ctx.arc(burst.x, burst.y, radius, 0, Math.PI * 2);
      ctx.stroke();
      // Mic nucleu luminos, separat de inel, pentru senzația de explozie.
      ctx.globalAlpha = (1 - ringProgress) * 0.55;
      ctx.fillStyle = '#FFF8E7';
      ctx.beginPath();
      ctx.arc(burst.x, burst.y, lowPerformance ? 2.3 : 3.0, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.globalAlpha = 1;

    for (let i = 0; i < particles.length; i += 1) {
      const p = particles[i];
      if (elapsed < p.delay) {
        activeParticles += 1;
        continue;
      }
      if (p.age >= p.life) continue;

      p.x += p.vx;
      p.y += p.vy;
      p.vy += p.gravity;
      p.vx *= 0.986;
      p.age += 1;
      activeParticles += 1;

      const alpha = Math.min(Math.min(1, p.age / 3), Math.max(0, (p.life - p.age) / 10));
      if (alpha <= 0) continue;

      // Dâre fină + punct luminos; fără blur sau biblioteci externe.
      ctx.globalAlpha = alpha * 0.75;
      ctx.strokeStyle = p.color;
      ctx.lineWidth = Math.max(1.15, p.size * 0.82);
      ctx.beginPath();
      ctx.moveTo(p.x - p.vx * 1.7, p.y - p.vy * 1.7);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();

      ctx.globalAlpha = alpha;
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.globalAlpha = 1;
    if (activeParticles > 0) state.raf = requestAnimationFrame(draw);
    else finish();
  }

  state.raf = requestAnimationFrame(draw);
  return true;
}
function getCartPageTotal(cartPageElement) {
  const cartPage = cartPageElement || document.querySelector('.anas-cart-page');
  if (!cartPage || cartPage.dataset.cartTotalCents === undefined) return null;
  const cents = Number(cartPage.dataset.cartTotalCents);
  return Number.isFinite(cents) ? Math.max(0, cents / 100) : null;
}

function getCheckoutValidationTotal(sourceElement) {
  // Cart drawer uses the live AnasCart model, even when /cart is behind the drawer.
  if (sourceElement && sourceElement.closest && sourceElement.closest('#cart-drawer')) {
    return Math.max(0, Number(AnasCart.getTotal() || 0));
  }

  const sourceCartPage = sourceElement && sourceElement.closest
    ? sourceElement.closest('.anas-cart-page')
    : null;
  if (sourceCartPage) {
    const pageTotal = getCartPageTotal(sourceCartPage);
    return pageTotal === null ? Math.max(0, Number(AnasCart.getTotal() || 0)) : pageTotal;
  }

  if (isAnasCartDrawerOpen()) {
    return Math.max(0, Number(AnasCart.getTotal() || 0));
  }

  const pageTotal = getCartPageTotal();
  return pageTotal === null ? Math.max(0, Number(AnasCart.getTotal() || 0)) : pageTotal;
}

/* Synchronizare fără refresh: pagina /cart rămâne sursa ei, drawer-ul își actualizează propria stare. */
/* Artificii doar pe pagina coșului: se lansează la trecerea reală de la sub 100 RON la 100 RON sau mai mult.
   Coșurile deja peste prag la încărcarea paginii nu declanșează animația. */
(function initAnasCartPageFireworks() {
  function cartTotalInLei(cart) {
    if (cart && typeof cart.total_price !== 'undefined') {
      const cents = Number(cart.total_price);
      if (Number.isFinite(cents)) return Math.max(0, cents / 100);
    }
    const pageTotal = getCartPageTotal();
    return pageTotal === null ? null : pageTotal;
  }

  function setInitialCartPageBaseline() {
    if (!document.querySelector('.anas-cart-page')) return;
    const initialTotal = getCartPageTotal();
    if (initialTotal === null) return;
    window.__anasCartPageFireworksPreviousTotal = initialTotal;
    window.__anasCartPageFireworksBaselineReady = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setInitialCartPageBaseline, { once: true });
  } else {
    setInitialCartPageBaseline();
  }

  window.addEventListener('anas:cart-page-updated', function (event) {
    if (!document.querySelector('.anas-cart-page')) return;
    const cart = event && event.detail && event.detail.cart;
    if (!cart || !Array.isArray(cart.items)) return;

    const currentTotal = cartTotalInLei(cart);
    if (currentTotal === null) return;

    if (window.__anasCartPageFireworksBaselineReady !== true ||
        typeof window.__anasCartPageFireworksPreviousTotal !== 'number') {
      window.__anasCartPageFireworksPreviousTotal = currentTotal;
      window.__anasCartPageFireworksBaselineReady = true;
      return;
    }

    const previousTotal = window.__anasCartPageFireworksPreviousTotal;
    if (previousTotal < MINIMUM_ORDER && currentTotal >= MINIMUM_ORDER) {
      launchAnasMinimumOrderFireworks();
    }

    // Reînarmăm doar după ce totalul scade sub prag; cât timp rămâne >=100,
    // actualizările ulterioare nu repetă artificiile.
    window.__anasCartPageFireworksPreviousTotal = currentTotal;
  });
})();

window.addEventListener('anas:cart-page-updated', function (event) {
  const cart = event && event.detail && event.detail.cart;
  if (!cart || !Array.isArray(cart.items)) return;
  if (AnasCart._quantityRequestInFlight || Object.keys(AnasCart._pendingQuantities || {}).length) return;

  AnasCart._loadSequence += 1;
  AnasCart._applyCartSnapshot(cart);
  AnasCart.updateUI();
  updateMinimumOrderCheck();
});


function updateMinimumOrderCheck() {
  const total = Math.max(0, Number(AnasCart.getTotal() || 0));
  const cartPageTotal = getCartPageTotal();
  const checkoutButtons = document.querySelectorAll(
    'a[href*="/checkout"], button[name="checkout"], [data-checkout]'
  );
  const cartFooter = document.getElementById('cart-footer');
  if (!cartFooter) return;

  // Pe pagina /cart, pragul este verificat de listener-ul dedicat de mai jos.
  // În restul site-ului, permitem artificii doar pentru o trecere reală a totalului
  // în timp ce utilizatorul folosește coșul; o trecere înainte de deschiderea drawer-ului
  // este pusă în așteptare o singură dată.
  if (window.__anasMinimumOrderBaselineReady === true) {
    if (document.querySelector('.anas-cart-page')) {
      window.__anasPendingMinimumOrderFireworks = false;
      window.__anasDrawerPreviousTotal = total;
    } else {
      const previousDrawerTotal = window.__anasDrawerPreviousTotal;
      if (total < MINIMUM_ORDER) {
        window.__anasPendingMinimumOrderFireworks = false;
      } else if (
        typeof previousDrawerTotal === 'number' &&
        previousDrawerTotal < MINIMUM_ORDER &&
        total >= MINIMUM_ORDER
      ) {
        if (isAnasCartDrawerOpen()) {
          launchAnasMinimumOrderFireworks();
        } else {
          window.__anasPendingMinimumOrderFireworks = true;
        }
      }
      window.__anasDrawerPreviousTotal = total;
    }
  }

  ensureMinimumOrderProgressStyles();

  let message = document.getElementById('minimum-order-message');
  if (!message) {
    message = document.createElement('div');
    message.id = 'minimum-order-message';
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.innerHTML = `
      <div class="anas-minimum-progress" aria-label="Progres către comanda minimă de 100 RON">
        <div class="anas-minimum-progress-head">
          <span class="anas-minimum-progress-kicker">Obiectiv comandă</span>
          <span class="anas-minimum-progress-total">0 / 100 RON</span>
        </div>
        <div class="anas-minimum-progress-track" role="progressbar" aria-label="Progres comandă minimă" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
          <div class="anas-minimum-progress-fill"></div>
        </div>
        <div class="anas-minimum-progress-foot">
          <span class="anas-minimum-progress-label">Mai ai până la obiectiv</span>
          <strong class="anas-minimum-progress-remaining">100 RON</strong>
        </div>
      </div>
    `;
    cartFooter.insertBefore(message, cartFooter.firstChild);
  }

  const percentage = Math.max(0, Math.min(100, (total / MINIMUM_ORDER) * 100));
  const remaining = Math.max(0, MINIMUM_ORDER - total);
  const complete = total >= MINIMUM_ORDER;
  const progressCard = message.querySelector('.anas-minimum-progress');
  const progressTrack = message.querySelector('.anas-minimum-progress-track');
  const progressFill = message.querySelector('.anas-minimum-progress-fill');
  const progressKicker = message.querySelector('.anas-minimum-progress-kicker');
  const progressTotal = message.querySelector('.anas-minimum-progress-total');
  const progressLabel = message.querySelector('.anas-minimum-progress-label');
  const progressRemaining = message.querySelector('.anas-minimum-progress-remaining');

  message.style.display = 'block';
  /* Fără chenar/card în jurul indicatorului; rămân doar textele și bara. */
  message.style.cssText = 'display:block;width:100%;margin:0 0 8px;padding:0;border:0;background:transparent;box-shadow:none;box-sizing:border-box;';

  if (progressCard) progressCard.classList.toggle('is-complete', complete);

  /* Subtotalul apare numai când pragul minim este atins.
     setProperty(..., 'important') îl ascunde și peste regulile CSS cu display:flex!important. */
  const subtotalRow = document.querySelector('#cart-drawer .cart-subtotal');
  if (subtotalRow) {
    subtotalRow.style.setProperty('display', complete ? 'flex' : 'none', 'important');
    subtotalRow.setAttribute('aria-hidden', complete ? 'false' : 'true');
  }
  if (progressFill) progressFill.style.width = percentage.toFixed(2) + '%';
  if (progressTrack) progressTrack.setAttribute('aria-valuenow', String(Math.round(percentage)));
  if (progressKicker) progressKicker.textContent = complete ? 'Obiectiv atins' : 'Obiectiv comandă';
  if (progressTotal) progressTotal.textContent = Math.min(total, MINIMUM_ORDER).toFixed(0) + ' / 100 RON';
  if (progressLabel) progressLabel.textContent = complete ? 'Pragul minim a fost îndeplinit' : 'Mai ai până la obiectiv';
  if (progressRemaining) progressRemaining.textContent = complete ? 'ATINS' : remaining.toFixed(0) + ' RON';

  /* Sub 100 RON, butonul explică elegant suma lipsă și nu navighează. */
  const cartGoButton = document.querySelector('#cart-drawer .cart-go-button');
  if (cartGoButton) {
    const cartButtonBlocked = total < MINIMUM_ORDER;
    cartGoButton.setAttribute('aria-disabled', cartButtonBlocked ? 'true' : 'false');
    cartGoButton.dataset.minimumOrderBlocked = cartButtonBlocked ? 'true' : 'false';
    cartGoButton.classList.toggle('is-minimum-order-blocked', cartButtonBlocked);
    cartGoButton.textContent = cartButtonBlocked
      ? `Mai adaugă ${remaining.toFixed(0)} RON`
      : 'Mergi la coș';
    cartGoButton.title = cartButtonBlocked
      ? `Mai ai nevoie de ${remaining.toFixed(0)} RON pentru comanda minimă de 100 RON.`
      : 'Mergi la coș';
    cartGoButton.style.opacity = '';
    cartGoButton.style.cursor = cartButtonBlocked ? 'not-allowed' : '';
  }

  checkoutButtons.forEach(btn => {
    // Checkout-ul din pagina normală folosește totalul său actual;
    // toate celelalte acțiuni folosesc totalul live Shopify din AnasCart.
    const sourcePage = btn.closest('.anas-cart-page');
    const pageTotal = sourcePage ? getCartPageTotal(sourcePage) : null;
    const buttonTotal = pageTotal === null ? total : pageTotal;

    if (buttonTotal < MINIMUM_ORDER) {
      btn.dataset.minimumOrderBlocked = 'true';
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';
      btn.setAttribute('aria-disabled', 'true');
    } else {
      delete btn.dataset.minimumOrderBlocked;
      // Nu forțăm activarea dacă este blocat din alt motiv.
      if (!btn.dataset.perishableBlocked) {
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
        btn.removeAttribute('aria-disabled');
      }
    }
  });
}


/* Verificare la click pe Finalizare comandă */
document.addEventListener('click', function(event) {

  const checkoutButton = event.target.closest(
    '#cart-drawer .cart-go-button, a[href*="/checkout"], button[name="checkout"], [data-checkout]'
  );

  if (!checkoutButton) return;

  const total = getCheckoutValidationTotal(checkoutButton);

  if (total < MINIMUM_ORDER) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const remaining = Math.max(0, MINIMUM_ORDER - total);

    showToast(
      `Comanda minimă este de ${MINIMUM_ORDER} RON. Mai ai nevoie de ${remaining.toFixed(0)} RON.`,
      'error'
    );
  }
}, true);


/* Verificăm după modificarea coșului */
const originalRenderDrawer = AnasCart.renderDrawer.bind(AnasCart);

AnasCart.renderDrawer = function() {
  originalRenderDrawer();

  setTimeout(function() {
    updateMinimumOrderCheck();
  }, 100);
};


/* Verificare inițială */
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    updateMinimumOrderCheck();
  }, 300);
});
/* =========================================================
   MĂCELĂRIA ANAS — PREMIUM LANGUAGE SWITCHER
   RO / EN / AR
   ========================================================= */

(function () {
  'use strict';

  const LANGUAGES = {
    ro: {
      code: 'Română',
      name: 'Română',
      flag: 'https://flagcdn.com/w40/ro.png'
    },
    en: {
      code: 'English',
      name: 'English',
      flag: 'https://flagcdn.com/w40/us.png'
    },
    ar: {
      code: 'العربية',
      name: 'العربية',
      flag: 'https://flagcdn.com/w40/sa.png'
    }
  };

  function globeSVG() {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9"></circle>
        <path d="M3 12h18"></path>
        <path d="M12 3c2.5 2.5 3.8 5.5 3.8 9s-1.3 6.5-3.8 9"></path>
        <path d="M12 3c-2.5 2.5-3.8 5.5-3.8 9s1.3 6.5 3.8 9"></path>
      </svg>
    `;
  }

  function getCurrentLanguage(select) {
    return (
      select?.value ||
      document.documentElement.lang ||
      'ro'
    ).toLowerCase().split('-')[0];
  }

  function createSwitcher(form, index) {
    if (!form || form.dataset.anasLanguageReady === 'true') return;

    const select = form.querySelector(
      'select[name="language_code"]'
    );

    if (!select) return;

    form.dataset.anasLanguageReady = 'true';

    const currentLanguage = getCurrentLanguage(select);

    /* Buton */
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'anas-language-custom';
    button.setAttribute('aria-haspopup', 'true');
    button.setAttribute('aria-expanded', 'false');

    button.innerHTML = `
      <span class="language-globe">
        ${globeSVG()}
      </span>
      <span class="language-code"></span>
      <span class="language-chevron" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none" focusable="false">
          <path d="m5.5 7.5 4.5 4.5 4.5-4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </span>
    `;

    /* Dropdown */
    const dropdown = document.createElement('div');
    dropdown.className = 'anas-language-dropdown';
    dropdown.setAttribute('role', 'menu');

    Object.keys(LANGUAGES).forEach(function (code) {
      const lang = LANGUAGES[code];

      const option = document.createElement('button');
      option.type = 'button';
      option.className = 'anas-language-option';
      option.dataset.language = code;
      option.setAttribute('role', 'menuitem');

      option.innerHTML = `
        <span class="language-flag">
          <img
            src="${lang.flag}"
            alt="${lang.name}"
            loading="lazy"
          >
        </span>

        <span class="language-name">
          ${lang.name}
        </span>

        <span class="language-check">✓</span>
      `;

      option.addEventListener('click', function () {
        const selectedCode = this.dataset.language;

        if (!selectedCode || selectedCode === getCurrentLanguage(select)) {
          closeAll();
          return;
        }

        select.value = selectedCode;

        closeAll();

        /*
         * Folosim mecanismul Shopify existent.
         * Dacă tema are onchange="this.form.submit()",
         * formularul va fi trimis automat.
         */
        select.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });

      dropdown.appendChild(option);
    });

    form.classList.add(
      index === 0
        ? 'anas-language-top'
        : 'anas-language-header'
    );

    form.appendChild(button);
    form.appendChild(dropdown);

    function refreshState() {
      const active = getCurrentLanguage(select);
      const language = LANGUAGES[active] || LANGUAGES.ro;

      const codeElement =
        button.querySelector('.language-code');

      if (codeElement) {
        codeElement.textContent = language.name;
      }

      dropdown
        .querySelectorAll('.anas-language-option')
        .forEach(function (option) {
          const isActive =
            option.dataset.language === active;

          option.classList.toggle(
            'active',
            isActive
          );
        });
    }

    function open() {
      closeAll(form);

      form.classList.add('language-open');
      button.setAttribute('aria-expanded', 'true');

      refreshState();
    }

    function close() {
      form.classList.remove('language-open');
      button.setAttribute('aria-expanded', 'false');
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (
        form.classList.contains('language-open')
      ) {
        close();
      } else {
        open();
      }
    });

    refreshState();
  }

  function closeAll(except) {
    document
      .querySelectorAll(
        '.anas-language-form.language-open'
      )
      .forEach(function (form) {
        if (form !== except) {
          form.classList.remove('language-open');

          const button =
            form.querySelector(
              '.anas-language-custom'
            );

          if (button) {
            button.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        }
      });
  }

  function initLanguageSwitchers() {
    document
      .querySelectorAll(
        '.anas-language-form'
      )
      .forEach(function (form, index) {
        createSwitcher(form, index);
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (
        !event.target.closest(
          '.anas-language-form'
        )
      ) {
        closeAll();
      }
    }
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Escape') {
        closeAll();
      }
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initLanguageSwitchers
    );
  } else {
    initLanguageSwitchers();
  }

  /*
   * Shopify poate re-renderiza anumite componente.
   * Reinițializăm fără să duplicăm selectorul.
   */
  // Evităm un MutationObserver pe tot document.body: paginile cu multe
  // produse/coș generează multe mutații fără legătură cu selectorul de limbă.
  // Shopify anunță explicit când reîncarcă o secțiune în Theme Editor.
  document.addEventListener('shopify:section:load', initLanguageSwitchers);

})();
/* MĂCELĂRIA ANAS — MOBILE NAV ROUTING + SINGLE ACTIVE STATE
   Add this script at the END of assets/theme.js. Do not replace theme.js. */
(function () {
  'use strict';

  var NAV_ITEMS = [
    '.mobile-bottom-nav .mobile-nav-item',
    '.anas-mobile-bottom-nav .mobile-nav-item',
    '.anas-mobile-nav .mobile-nav-item',
    '.bottom-nav .mobile-nav-item'
  ].join(',');
  var NAV_CONTAINERS = '.mobile-bottom-nav, .anas-mobile-bottom-nav, .anas-mobile-nav, .bottom-nav';
  var OWN_CLASS = 'anas-nav-active';
  var syncTimer = null;

  function isVisible(element) {
    return !!(element && element.getClientRects && element.getClientRects().length);
  }

  function itemLabel(item) {
    if (!item) return '';
    var labelNodes = item.querySelectorAll('[data-nav-label], .mobile-nav-label, .nav-label, .mobile-bottom-nav__label');
    var labelText = '';
    for (var i = 0; i < labelNodes.length; i++) {
      labelText += ' ' + (labelNodes[i].textContent || '');
    }
    return [
      item.getAttribute('aria-label') || '',
      item.getAttribute('title') || '',
      item.getAttribute('data-nav') || '',
      item.getAttribute('data-nav-key') || '',
      item.getAttribute('data-label') || '',
      labelText,
      item.innerText || item.textContent || ''
    ].join(' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function itemKey(item) {
    var text = itemLabel(item);
    if (/wishlist|favorite|favoritele/.test(text)) return 'wishlist';
    if (/\bcart\b|\bcoș\b|\bcos\b/.test(text)) return 'cart';
    if (/\baccount\b|\bcont\b|\bcontul\b/.test(text)) return 'account';
    if (/\bmagazin\b|\bshop\b|\bproduse\b|\btoate produsele\b/.test(text)) return 'shop';
    if (/\bhome\b|\bacasă\b|\bacasa\b/.test(text)) return 'home';
    return '';
  }

  function getNavItems() {
    var items = Array.prototype.slice.call(document.querySelectorAll(NAV_ITEMS));
    items = items.filter(isVisible);

    /* Fallback only if this theme version lacks .mobile-nav-item wrappers. */
    if (!items.length) {
      var containers = document.querySelectorAll(NAV_CONTAINERS);
      for (var c = 0; c < containers.length; c++) {
        var direct = containers[c].querySelectorAll(':scope > a, :scope > button, :scope > [role="button"]');
        for (var d = 0; d < direct.length; d++) {
          if (isVisible(direct[d])) items.push(direct[d]);
        }
      }
    }

    /* De-duplicate nodes if a theme matches more than one compatible selector. */
    return items.filter(function (item, index) { return items.indexOf(item) === index; });
  }

  function drawerIsOpen(selectors) {
    var drawer = document.querySelector(selectors);
    if (!drawer) return false;
    var ariaHidden = drawer.getAttribute('aria-hidden');
    return drawer.classList.contains('open') ||
      drawer.classList.contains('active') ||
      drawer.classList.contains('is-open') ||
      ariaHidden === 'false';
  }

  function pageKey() {
    var path = (window.location.pathname || '/').replace(/\/{2,}/g, '/').replace(/\/$/, '') || '/';
    /* Treat common locale prefixes (for example /ro) as the storefront root. */
    path = path.replace(/^\/(ro|en|de|fr|it|es)(?=\/|$)/i, '') || '/';
    path = path.replace(/\/$/, '') || '/';

    if (path === '/') return 'home';
    if (/^\/account(?:\/|$)/i.test(path)) return 'account';
    if (/^\/pages\/categorii(?:\/|$)/i.test(path) || /^\/collections(?:\/|$)/i.test(path) || /^\/products(?:\/|$)/i.test(path) || /^\/search(?:\/|$)/i.test(path)) return 'shop';
    return '';
  }

  function syncActiveItem() {
    syncTimer = null;
    var items = getNavItems();
    if (!items.length) return;

    var activeKey = '';
    /* Open drawers take precedence over the current page. */
    if (drawerIsOpen('#wishlist-drawer, #WishlistDrawer, [data-wishlist-drawer].open, [data-wishlist-drawer].active')) {
      activeKey = 'wishlist';
    } else if (drawerIsOpen('#cart-drawer, #CartDrawer, [data-cart-drawer].open, [data-cart-drawer].active')) {
      activeKey = 'cart';
    } else {
      activeKey = pageKey();
    }

    var chosen = null;
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove(OWN_CLASS);
      if (itemKey(items[i]) === activeKey && !chosen) chosen = items[i];
    }
    if (chosen) chosen.classList.add(OWN_CLASS);
  }

  function queueSync() {
    if (syncTimer !== null) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncActiveItem, 70);
  }

  function shopDestination() {
    /* Use the store's existing collection URL if available; fall back to Shopify's all-products route. */
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      try {
        var url = new URL(links[i].getAttribute('href'), window.location.origin);
        if (url.origin === window.location.origin && /\/collections\/all\/?$/.test(url.pathname)) {
          return '/collections/toate-produsele' + url.search + url.hash;
        }
      } catch (e) { /* Ignore malformed links and keep searching. */ }
    }
    return '/collections/toate-produsele';
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var item = target.closest(NAV_ITEMS);
    if (!item) {
      var fallbackContainer = target.closest(NAV_CONTAINERS);
      if (fallbackContainer) {
        item = target.closest(':scope > a, :scope > button, :scope > [role="button"]');
      }
    }
    if (!item) return;

    /* Lasă linkurile native să navigheze normal. În Theme Editor, nu forța
       window.location.assign și nu bloca evenimentul Shopify de preview. */
    queueSync();
    window.setTimeout(queueSync, 180);
    window.setTimeout(queueSync, 420);
  }, true);

  window.addEventListener('pageshow', queueSync);
  window.addEventListener('popstate', queueSync);
  window.addEventListener('load', function () {
    queueSync();
    window.setTimeout(queueSync, 250);
    window.setTimeout(queueSync, 700);
  }, { once: true });
  window.addEventListener('resize', queueSync, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync, { once: true });
  } else {
    queueSync();
  }

  if (window.MutationObserver && document.body) {
    // Observe only the drawer roots whose open/closed state affects bottom navigation.
    // This avoids running the callback for unrelated class changes across the whole page.
    var drawerRoots = document.querySelectorAll(
      '#cart-drawer, #CartDrawer, #wishlist-drawer, #WishlistDrawer, [data-cart-drawer], [data-wishlist-drawer]'
    );
    if (drawerRoots.length) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var changed = mutations[i].target;
          if (changed.matches && changed.matches(
            '#cart-drawer, #CartDrawer, #wishlist-drawer, #WishlistDrawer, [data-cart-drawer], [data-wishlist-drawer]'
          )) {
            queueSync();
            return;
          }
        }
      });
      drawerRoots.forEach(function (drawer) {
        observer.observe(drawer, {
          attributes: true,
          attributeFilter: ['class', 'aria-hidden']
        });
      });
    }
  }})();

/* DRAWER TRIGGERS — prevent native navigation; keep the current page behind cart/wishlist */
(function () {
  if (window.__anasDrawerClickGuardInstalled) return;
  window.__anasDrawerClickGuardInstalled = true;

  // These are overlay controls, never links or form-submit actions.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest(
      'button[onclick*="openCart"], button[onclick*="openWishlist"]'
    );
    if (!trigger) return;

    // Cancel native submit/navigation while preserving the existing inline action
    // (including closeAccountMenu/closeAnasMenu calls on header menu buttons).
    event.preventDefault();
  }, true);
})();


/* ANAS_FULL_LOCALE_UI_V1
 * Translate fixed storefront UI strings without touching product/customer content.
 * Product, collection, page and policy copy must be translated in Shopify's language editor.
 */
(function () {
  'use strict';
  var LANG = String((document.documentElement.lang || 'ro').toLowerCase().split('-')[0]);
  if (['ro','en','ar'].indexOf(LANG) < 0) LANG = 'ro';

  var ROWS = [
    ['Call now','Sună acum','اتصل الآن'],
    ['Search','Caută','بحث'],
    ['Search products','Caută produse','ابحث عن المنتجات'],
    ['Shop','Magazin','المتجر'],
    ['Account','Cont','الحساب'],
    ['Open cart','Deschide coșul','افتح السلة'],
    ['Cart','Coș','السلة'],
    ['Wishlist','Favorite','المفضلة'],
    ['Location','Locație','الموقع'],
    ['Change location','Schimbă locația','تغيير الموقع'],
    ['Change language','Schimbă limba','تغيير اللغة'],
    ['Home','Acasă','الرئيسية'],
    ['Categories','Categorii','الفئات'],
    ['All categories','Toate categoriile','جميع الفئات'],
    ['Tap here for all categories','Apasă aici pentru toate categoriile','اضغط هنا لعرض جميع الفئات'],
    ['You will be taken to the homepage','Vei fi dus la pagina principală','سيتم نقلك إلى الصفحة الرئيسية'],
    ['Add to cart','Adaugă în coș','أضف إلى السلة'],
    ['Add to wishlist','Adaugă în favorite','أضف إلى المفضلة'],
    ['Remove from wishlist','Elimină din favorite','إزالة من المفضلة'],
    ['Sold out','Stoc epuizat','نفد المخزون'],
    ['Sold out','STOC EPUIZAT','نفد المخزون'],
    ['Your Cart','Coșul tău','سلتك'],
    ['Your cart is empty','Coșul tău este gol','سلتك فارغة'],
    ['Products you added','Produsele adăugate de tine','المنتجات التي أضفتها'],
    ['Add products you like','Adaugă produsele care îți plac','أضف المنتجات التي تعجبك'],
    ['and you will find them here quickly.','și le vei găsi aici rapid.','وستجدها هنا بسرعة.'],
    ['DISCOVER PRODUCTS','DESCOPERĂ PRODUSELE','اكتشف المنتجات'],
    ['Go to cart','Mergi la coș','اذهب إلى السلة'],
    ['Checkout','Finalizează comanda','إتمام الشراء'],
    ['Subtotal','Subtotal','المجموع الفرعي'],
    ['Continue shopping','Continuă cumpărăturile','متابعة التسوق'],
    ['Remove','Elimină','إزالة'],
    ['Delete','Șterge','حذف'],
    ['Quantity','Cantitate','الكمية'],
    ['Loading...','Se încarcă...','جارٍ التحميل...'],
    ['Loading','Se încarcă','جارٍ التحميل'],
    ['Save','Salvează','حفظ'],
    ['Cancel','Anulează','إلغاء'],
    ['Close','Închide','إغلاق'],
    ['Settings','Setări','الإعدادات'],
    ['Cookie settings','Setări cookie-uri','إعدادات ملفات تعريف الارتباط'],
    ['We use cookies for analytics and advertising (Google Ads). You can choose what you accept.','Folosim cookie-uri pentru analiză și publicitate (Google Ads). Poți alege ce accepți.','نستخدم ملفات تعريف الارتباط للتحليلات والإعلانات (Google Ads). يمكنك اختيار ما توافق عليه.'],
    ['Essential for cart, session and login. Cannot be disabled.','Esențiale pentru coș, sesiune și autentificare. Nu pot fi dezactivate.','ضرورية للسلة والجلسة وتسجيل الدخول. لا يمكن تعطيلها.'],
    ['Help us understand how the site is used.','Ne ajută să înțelegem cum este folosit site-ul.','تساعدنا على فهم كيفية استخدام الموقع.'],
    ['Relevant ads and remarketing through Google Ads.','Reclame relevante și remarketing prin Google Ads.','إعلانات ملائمة وإعادة التسويق عبر Google Ads.'],
    ['Save settings','Salvează setările','حفظ الإعدادات'],
    ['Special Offers','Oferte speciale','عروض خاصة'],
    ['See all','Vezi toate','عرض الكل'],
    ['View all','Vezi toate','عرض الكل'],
    ['Price','Preț','السعر'],
    ['Description','Descriere','الوصف'],
    ['Details','Detalii','التفاصيل'],
    ['Brand','Brand','العلامة التجارية'],
    ['Availability','Disponibilitate','التوفر'],
    ['In stock','În stoc','متوفر'],
    ['Out of stock','Stoc epuizat','نفد المخزون'],
    ['Sale','Reducere','تخفيض'],
    ['SALE','REDUCERE','تخفيض'],
    ['Add','Adaugă','إضافة'],
    ['Back','Înapoi','رجوع'],
    ['Next','Următorul','التالي'],
    ['Previous','Anteriorul','السابق'],
    ['Page','Pagina','الصفحة'],
    ['No products found','Nu s-au găsit produse','لم يتم العثور على منتجات'],
    ['No results found','Nu s-au găsit rezultate','لم يتم العثور على نتائج'],
    ['Try another search','Încearcă o altă căutare','جرّب بحثًا آخر'],
    ['Call us','Sună-ne','اتصل بنا'],
    ['WhatsApp','WhatsApp','واتساب'],
    ['Privacy policy','Politica de confidențialitate','سياسة الخصوصية'],
    ['Terms of service','Termeni și condiții','شروط الخدمة'],
    ['Refund policy','Politica de retur','سياسة الاسترداد'],
    ['Contact','Contact','اتصل بنا'],
    ['About us','Despre noi','من نحن'],
    ['Newsletter','Buletin informativ','النشرة البريدية'],
    ['Email address','Adresă de e-mail','عنوان البريد الإلكتروني'],
    ['Subscribe','Abonează-te','اشترك'],
    ['Thank you','Mulțumim','شكرًا لك'],
    ['Product added to cart','Produs adăugat în coș','تمت إضافة المنتج إلى السلة'],
    ['Added to Wishlist','Adăugat în favorite','تمت الإضافة إلى المفضلة'],
    ['Removed from Wishlist','Eliminat din favorite','تمت الإزالة من المفضلة'],
    ['This product is no longer in stock.','Acest produs nu mai este în stoc.','هذا المنتج لم يعد متوفرًا.'],
    ['The product could not be identified.','Produsul nu a putut fi identificat.','تعذّر تحديد المنتج.'],
    ['The selected variant was not found.','Varianta produsului nu a fost găsită.','لم يتم العثور على الخيار المحدد للمنتج.'],
    ['Try again','Încearcă din nou','حاول مرة أخرى'],
    ['Delivery','Livrare','التوصيل'],
    ['Delivery only in Bucharest','Livrare doar în București','التوصيل داخل بوخارست فقط'],
    ['Free delivery','Livrare gratuită','توصيل مجاني'],
    ['Minimum order','Comandă minimă','الحد الأدنى للطلب'],
    ['Minimum order value','Valoarea minimă a comenzii','الحد الأدنى لقيمة الطلب'],
    ['Choose a location','Alege locația','اختر الموقع'],
    ['Choose language','Alege limba','اختر اللغة'],
    ['Romanian','Română','الرومانية'],
    ['English','Engleză','الإنجليزية'],
    ['Arabic','Arabă','العربية'],
    ['All rights reserved','Toate drepturile rezervate','جميع الحقوق محفوظة'],
    ['Beef','Carne de vită','لحم بقري'],
    ['Nuts and dates','Nuci și curmale','المكسرات والتمر'],
    ['Pantry','Cămară','المؤونة'],
    ['Tea and coffee','Ceai și cafea','الشاي والقهوة'],
    ['Grains and legumes','Cereale și leguminoase','الحبوب والبقوليات'],
    ['Oils and sauces','Uleiuri și sosuri','الزيوت والصلصات'],
    ['Ready meals','Mâncăruri gata','وجبات جاهزة'],
    ['Bakery','Panificație','المخبوزات'],
    ['Drinks','Băuturi','المشروبات'],
    ['Poultry','Carne de pasăre','لحوم الدواجن'],
    ['Lamb','Carne de oaie','لحم الضأن'],
    ['Pork','Carne de porc','لحم الخنزير'],
    ['Chicken','Carne de pui','لحم الدجاج'],
    ['Fresh meat','Carne proaspătă','لحم طازج'],
    ['Add to favorites','Adaugă la favorite','أضف إلى المفضلة'],
    ['Continue to checkout','Continuă la finalizarea comenzii','تابع إلى إتمام الشراء'],
    ['Your wishlist is empty','Lista ta de favorite este goală','قائمة المفضلة فارغة'],
    ['Your order','Comanda ta','طلبك'],
    ['Order summary','Sumarul comenzii','ملخص الطلب'],
    ['Shipping address','Adresa de livrare','عنوان التوصيل'],
    ['Payment method','Metoda de plată','طريقة الدفع'],
    ['Delivery address','Adresa de livrare','عنوان التوصيل'],
    ['Out of stock. This product cannot be added to the wishlist or cart.','Stoc epuizat. Produsul nu poate fi adăugat în wishlist sau în coș.','نفد المخزون. لا يمكن إضافة هذا المنتج إلى المفضلة أو السلة.'],
    ["Menu", "Meniu", "القائمة"],
    ["Welcome", "Bine ai venit", "مرحبًا"],
    ["My profile", "Profilul meu", "ملفي الشخصي"],
    ["My orders", "Comenzile mele", "طلباتي"],
    ["Log out", "Deconectare", "تسجيل الخروج"],
    ["Your Anas account", "Contul tău Anas", "حسابك لدى أنس"],
    ["Sign in", "Conectează-te", "تسجيل الدخول"],
    ["Create an account", "Creează un cont", "إنشاء حساب"],
    ["Save your orders and track them more easily.", "Salvează comenzile și urmărește-le mai ușor.", "احفظ طلباتك وتابعها بسهولة أكبر."],
    ["Welcome!", "Bine ai venit!", "مرحبًا بك!"],
    ["Discover our halal products.", "Descoperă produsele noastre halal.", "اكتشف منتجاتنا الحلال."],
    ["All products", "Toate produsele", "جميع المنتجات"],
    ["Special prices", "Prețuri speciale", "أسعار خاصة"],
    ["Loading offers", "Se încarcă ofertele", "جارٍ تحميل العروض"],
    ["Sort by", "Sortează după", "ترتيب حسب"],
    ["Information", "Informații", "معلومات"],
    ["Dairy", "Lactate", "منتجات الألبان"],
    ["Frozen foods", "Alimente congelate", "أطعمة مجمدة"],
    ["Canned goods", "Conserve", "معلبات"],
    ["Sweets", "Dulciuri", "حلويات"],
    ["Payment methods", "Metode de plată", "طرق الدفع"],
    ["Privacy", "Confidențialitate", "الخصوصية"],
    ["Terms", "Termeni", "الشروط"],
    ["Returns", "Retur", "المرتجعات"],
    ["Track order", "Urmărește comanda", "تتبع الطلب"],
    ["How it works", "Cum funcționează", "كيف يعمل"],
    ["Support", "Asistență", "الدعم"],
    ["Halal promise", "Promisiunea halal", "وعد الحلال"],
    ["Quick selections", "Selecții rapide", "اختيارات سريعة"],
    ["Total for the selected option", "Total pentru varianta selectată", "الإجمالي للخيار المحدد"],
    ["Preparation mode", "Mod de preparare", "طريقة التحضير"],
    ["Choose preparation method", "Alege modul de preparare", "اختر طريقة التحضير"],
    ["You might also like", "Poate îți place și", "قد يعجبك أيضًا"],
    ["From the same category", "Din aceeași categorie", "من الفئة نفسها"],
    ["View all categories", "Vezi toate categoriile", "عرض جميع الفئات"],
    ["Your favorites", "Favoritele tale", "مفضلاتك"],
    ["Products you've saved", "Produsele pe care le-ai salvat", "المنتجات التي حفظتها"],
    ["You don't have any favorite products yet", "Încă nu ai produse favorite", "ليس لديك منتجات مفضلة بعد"],
    ["Save the products you like", "Salvează produsele care îți plac", "احفظ المنتجات التي تعجبك"],
    ["Page not found", "Pagina nu a fost găsită", "الصفحة غير موجودة"],
    ["This page doesn't exist or has been moved.", "Această pagină nu există sau a fost mutată.", "هذه الصفحة غير موجودة أو تم نقلها."],
    ["Go home", "Mergi la pagina principală", "العودة إلى الصفحة الرئيسية"],
    ["Welcome back", "Bine ai revenit", "مرحبًا بعودتك"],
    ["Sign in to your account", "Intră în cont", "سجّل الدخول إلى حسابك"],
    ["Access your orders, history and wishlist.", "Accesează comenzile, istoricul și favoritele tale.", "يمكنك الوصول إلى طلباتك وسجلّك وقائمة المفضلة."],
    ["Email", "E-mail", "البريد الإلكتروني"],
    ["Password", "Parolă", "كلمة المرور"],
    ["Forgot your password?", "Ai uitat parola?", "هل نسيت كلمة المرور؟"],
    ["or", "sau", "أو"],
    ["Don't have an account?", "Nu ai cont?", "ليس لديك حساب؟"],
    ["Create a free account →", "Creează cont gratuit →", "أنشئ حسابًا مجانيًا →"],
    ["Secure data", "Date securizate", "بيانات آمنة"],
    ["Fast delivery", "Livrare rapidă", "توصيل سريع"],
    ["Create account", "Creează cont", "إنشاء حساب"],
    ["Order quickly, track deliveries and save favorite products.", "Comandă rapid, urmărește livrările și salvează produsele preferate.", "اطلب بسرعة، وتابع عمليات التوصيل واحفظ منتجاتك المفضلة."],
    ["First name", "Prenume", "الاسم الأول"],
    ["Last name", "Nume", "اسم العائلة"],
    ["Already have an account?", "Ai deja cont?", "لديك حساب بالفعل؟"],
    ["Sign in →", "Intră în cont →", "سجّل الدخول →"],
    ["Free account", "Cont gratuit", "حساب مجاني"],
    ["Items in cart", "Produse în coș", "منتجات في السلة"],
    ["Add more", "Mai adaugă", "أضف المزيد"],
    ["to continue.", "pentru a continua.", "للمتابعة."],
    ["Delivery cost, if applicable, will be shown at the next step.", "Costul livrării, dacă se aplică, va fi afișat la pasul următor.", "ستظهر تكلفة التوصيل، إن وجدت، في الخطوة التالية."],
    ["Secure checkout", "Finalizare comandă securizată", "إتمام شراء آمن"],
    ["You haven't selected any products", "Încă nu ai ales produsele", "لم تختر أي منتجات بعد"],
    ["Discover our selection and add your favorite products. You'll find them here when you're ready.", "Descoperă selecția noastră și adaugă produsele preferate. Le vei găsi aici când ești gata.", "اكتشف تشكيلتنا وأضف منتجاتك المفضلة. ستجدها هنا عندما تكون مستعدًا."],
    ["Discover categories", "Descoperă categoriile", "اكتشف الفئات"],
    ["Selected products, ready for the next step.", "Produsele alese de tine, pregătite pentru următorul pas.", "المنتجات التي اخترتها جاهزة للخطوة التالية."],
    ["Last step", "Ultimul pas", "الخطوة الأخيرة"],
    ["Delivery through courier", "Livrare prin curier", "التوصيل عبر شركة شحن"],
    ["All available products", "Toate produsele disponibile", "جميع المنتجات المتاحة"],
    ["Shop all", "Vezi toate produsele", "عرض جميع المنتجات"],
    ["Your account", "Contul tău", "حسابك"],
    ["Limited offers", "Oferte limitate", "عروض محدودة"],
    ["View all offers", "Vezi toate ofertele", "عرض جميع العروض"],
    ["List", "Lista", "قائمة العناصر"],
    ["Selected products", "Produsele selectate", "المنتجات المحددة"],
    ["Weight", "Greutate", "الوزن"],
    ["Choose weight", "Alege greutatea", "اختر الوزن"],
    ["Unavailable", "Indisponibil", "غير متاح"],
    ["The chosen products, ready for the next step.", "Produsele alese, pregătite pentru următorul pas.", "المنتجات المختارة جاهزة للخطوة التالية."],
    ["Products in cart", "Produse în coș", "منتجات في السلة"]
    // ANAS_TRANSLATION_EXPANSION_V1,
    ["All", "Toate", "الكل"],
    ["The largest halal online store in Romania. Certified products, fast delivery.", "Cel mai mare magazin halal online din România. Produse certificate, livrare rapidă.", "أكبر متجر حلال عبر الإنترنت في رومانيا. منتجات معتمدة وتوصيل سريع."],
    ["Products found", "produse găsite", "منتجات تم العثور عليها"],
    ["Coming soon!", "În curând!", "قريبًا!"],
    ["Choose your category", "Alege categoria dorită", "اختر الفئة المطلوبة"],
    ["Discover discounted products", "Descoperă produsele la preț redus", "اكتشف المنتجات المخفضة"],
    ["Open in Maps", "Deschide în Maps", "افتح في خرائط Google"],
    ["🍪 We use cookies", "🍪 Folosim cookie-uri", "🍪 نستخدم ملفات تعريف الارتباط"],
    ["Decline", "Refuz", "رفض"],
    ["Accept all", "Accept toate", "قبول الكل"],
    ["🔒 Essential cookies", "🔒 Cookie-uri necesare", "🔒 ملفات تعريف الارتباط الضرورية"],
    ["Always active", "Mereu active", "نشطة دائمًا"],
    ["Analytics (Google)", "Analytics (Google)", "التحليلات (Google)"],
    ["Advertising (Google Ads)", "Publicitate (Google Ads)", "الإعلانات (Google Ads)"],
    ["Daily delivery", "Livrare zilnică", "توصيل يومي"],
    ["Dairy & Eggs", "Lactate și ouă", "منتجات الألبان والبيض"],
    ["Shipping & Returns", "Livrare și retur", "الشحن والإرجاع"],
    ["PERISHABLE", "PERISABIL", "سريع التلف"],
    ["PERISHABLE PRODUCT", "PRODUS PERISABIL", "منتج سريع التلف"],
    ["Your list", "LISTA TA", "قائمتك"],
    ["Carefully selected.", "Selecție atentă.", "مختارة بعناية."],
    ["Halal products and clear information for your order.", "Produse halal și informații clare pentru comanda ta.", "منتجات حلال ومعلومات واضحة لطلبك."],
    ["See all results →", "Vezi toate rezultatele →", "عرض جميع النتائج →"],
    ["Halal meat • Oriental products", "CARNE HALAL • PRODUSE ORIENTALE", "لحوم حلال • منتجات شرقية"]
    // ANAS_TRANSLATION_EXPANSION_V2,
    ["Checking offers", "se verifică ofertele", "يجري التحقق من العروض"],
    ["Poultry category", "Pasăre", "الدواجن"],
    ["Order summary section", "Sumar comandă", "ملخص الطلبية"],
    ["📊 Analytics (Google)", "📊 Analiză (Google)", "📊 التحليلات (Google)"],
    ["🎯 Advertising (Google Ads)", "🎯 Publicitate (Google Ads)", "🎯 الإعلانات (Google Ads)"]
    // ANAS_TRANSLATION_POLISH_V1,
    ["My account", "Contul meu", "حسابي"],
    ["Anas menu", "MENIUL ANAS", "قائمة أنس"],
    ["ANAS BUTCHER SHOP · YOUR ORDER", "MĂCELĂRIA ANAS · COMANDA TA", "ملحمة أنس · طلبك"]
    // ANAS_TRANSLATION_DYNAMIC_PREFIX_V1,
    ["Niciun produs găsit pentru", "Niciun produs găsit pentru", "لم يتم العثور على منتجات لـ"],
    ["Rezultate pentru", "Rezultate pentru", "نتائج البحث عن"],
    ["Filtrăm produsele restricționate pe server, verificând cookie-ul de locație", "Filtrăm produsele restricționate pe server, verificând cookie-ul de locație", "نقوم بتصفية المنتجات المقيدة على الخادم عبر التحقق من ملف تعريف ارتباط الموقع"],
    ["Folosim cookie-uri", "Folosim cookie-uri", "نستخدم ملفات تعريف الارتباط"],
    ["Cel mai mare magazin halal online din România.", "Cel mai mare magazin halal online din România.", "أكبر متجر حلال عبر الإنترنت في رومانيا."],
    ["Produse certificate, livrare rapidă.", "Produse certificate, livrare rapidă.", "منتجات معتمدة وتوصيل سريع."]
    // ANAS_TRANSLATION_UI_AUDIT_V1
  ];

  var LOOKUP = Object.create(null);
  ROWS.forEach(function (row) {
    row.forEach(function (source, index) {
      var key = String(source || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
      if (key) LOOKUP[key] = row[LANG === 'ro' ? 1 : LANG === 'en' ? 0 : 2];
    });
  });

  var ATTRS = {
    'aria-label': {
      'search':'Caută|بحث',
      'search products':'Caută produse|ابحث عن المنتجات',
      'account':'Cont|الحساب',
      'wishlist':'Favorite|المفضلة',
      'cart':'Coș|السلة',
      'open cart':'Deschide coșul|افتح السلة',
      'change location':'Schimbă locația|تغيير الموقع',
      'call us':'Sună-ne|اتصل بنا',
      'close':'Închide|إغلاق',
      'remove':'Elimină|إزالة'
    },
    'placeholder': {
      'search products':'Caută produse|ابحث عن المنتجات',
      'search':'Caută|بحث',
      'email address':'Adresă de e-mail|عنوان البريد الإلكتروني'
    },
    'title': {
      'remove':'Elimină|إزالة',
      'close':'Închide|إغلاق'
    }
  };

  var PREFIX_ROWS = [
    ['No products found for', 'Niciun produs găsit pentru', 'لم يتم العثور على منتجات لـ'],
    ['Results for', 'Rezultate pentru', 'نتائج البحث عن'],
    ['View all (', 'Vezi toate (', 'عرض الكل ('],
    ['Call now', 'Sună acum', 'اتصل الآن']
  ];

  function translated(text) {
    var normalized = String(text || '').replace(/\s+/g, ' ').trim();
    var key = normalized.toLocaleLowerCase();
    if (Object.prototype.hasOwnProperty.call(LOOKUP, key)) return LOOKUP[key];
    for (var i = 0; i < PREFIX_ROWS.length; i++) {
      var row = PREFIX_ROWS[i];
      for (var j = 0; j < row.length; j++) {
        var source = String(row[j] || '').replace(/\s+/g, ' ').trim();
        var sourceKey = source.toLocaleLowerCase();
        if (sourceKey && key.indexOf(sourceKey) === 0 && normalized.length > source.length) {
          var target = row[LANG === 'ro' ? 1 : LANG === 'en' ? 0 : 2];
          var suffix = normalized.slice(source.length);
          if (row === PREFIX_ROWS[2]) {
            suffix = suffix.replace(/\\bproduse\\b/gi, LANG === 'ro' ? 'produse' : LANG === 'en' ? 'products' : 'منتجات');
          }
          return target + suffix;
        }
      }
    }
    return null;
  }

  function translateTextNode(node) {
    if (!node || !node.nodeValue || !node.parentElement) return;
    var parent = node.parentElement;
    if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|CODE|PRE|OPTION)$/i.test(parent.tagName)) return;
    if (parent.closest('[data-no-translate],script,style,noscript,textarea,code,pre,[contenteditable="true"]')) return;
    var original = node.nodeValue;
    var trimmed = original.replace(/\s+/g, ' ').trim();
    if (!trimmed) return;
    var value = translated(trimmed);
    if (value === null || value === trimmed) return;
    var leading = (original.match(/^\s*/) || [''])[0];
    var trailing = (original.match(/\s*$/) || [''])[0];
    node.nodeValue = leading + value + trailing;
  }

  function translateAttributes(root) {
    if (!root || root.nodeType !== 1) return;
    var nodes = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    nodes.forEach(function (el) {
      ['aria-label','title','placeholder','alt'].forEach(function (attr) {
        var raw = el.getAttribute(attr);
        if (!raw) return;
        var value = translated(raw);
        if (value !== null && value !== raw) el.setAttribute(attr, value);
      });
      if (el.tagName === 'INPUT' && /^(button|submit)$/i.test(el.type || '')) {
        var value = translated(el.value);
        if (value !== null && value !== el.value) el.value = value;
      }
    });
  }

  function translateTree(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      translateTextNode(root);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    if (root.nodeType === 1) translateAttributes(root);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(translateTextNode);
  }

  function applyDirection() {
    document.documentElement.lang = LANG;
    document.documentElement.dir = LANG === 'ar' ? 'rtl' : 'ltr';
    document.body && document.body.setAttribute('dir', LANG === 'ar' ? 'rtl' : 'ltr');
    if (!document.getElementById('anas-locale-rtl-style')) {
      var rtlStyle = document.createElement('style');
      rtlStyle.id = 'anas-locale-rtl-style';
      rtlStyle.textContent = [
        'html[dir="rtl"],html[dir="rtl"] body{direction:rtl}',
        'html[dir="rtl"] body,html[dir="rtl"] input,html[dir="rtl"] textarea,html[dir="rtl"] select{font-family:Tahoma,Arial,sans-serif}',
        'html[dir="rtl"] input:not([type="number"]):not([type="checkbox"]):not([type="radio"]),html[dir="rtl"] textarea,html[dir="rtl"] .cart-item-info,html[dir="rtl"] .wishlist-card-info,html[dir="rtl"] .product-info-desc{text-align:right}',
        'html[dir="rtl"] .anas-language-form,html[dir="rtl"] .anas-language-custom,html[dir="rtl"] .anas-language-dropdown{direction:ltr}',
        'html[dir="rtl"] .cart-item-footer,html[dir="rtl"] .wishlist-card-actions{direction:rtl}',
        'html[dir="rtl"] .cart-item-name,html[dir="rtl"] .cart-item-brand,html[dir="rtl"] .cart-item-property{ text-align:right }',
        'html[dir="rtl"] .product-card,html[dir="rtl"] .offers-product-card{direction:rtl}',
        'html[dir="rtl"] .top-bar,html[dir="rtl"] .site-footer{direction:rtl}',
        'html[dir="rtl"] [dir="ltr"],html[dir="rtl"] .price,html[dir="rtl"] [class*="price"],html[dir="rtl"] input[type="number"]{direction:ltr;unicode-bidi:embed}',
        'html[dir="rtl"] .header-search input{text-align:right}',
        'html[dir="rtl"] .mobile-bottom-nav,html[dir="rtl"] .anas-mobile-bottom-nav{direction:rtl}'
      ].join('');
      document.head.appendChild(rtlStyle);
    }
    document.documentElement.classList.toggle('anas-locale-ar', LANG === 'ar');
    document.documentElement.classList.toggle('anas-locale-en', LANG === 'en');
    if (document.body) document.body.classList.toggle('anas-locale-ar', LANG === 'ar');
  }

  function start() {
    applyDirection();
    translateTree(document.body);
    if (window.__anasLocaleObserver) window.__anasLocaleObserver.disconnect();
    var scheduled = false;
    window.__anasLocaleObserver = new MutationObserver(function (mutations) {
      if (scheduled) return;
      scheduled = true;
      Promise.resolve().then(function () {
        scheduled = false;
        mutations.forEach(function (mutation) {
          if (mutation.type === 'characterData') translateTextNode(mutation.target);
          else mutation.addedNodes && mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 || node.nodeType === 3) translateTree(node);
          });
        });
      });
    });
    window.__anasLocaleObserver.observe(document.body, {subtree:true, childList:true, characterData:true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', function (event) { translateTree(event.target); applyDirection(); });
})();
